import React, {
  ChangeEvent,
  // UIEvent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { connect, DispatchProp } from 'react-redux';
import {
  ClientDashboardModule,
  ClientModule,
  NotificationsModule,
  RoomModule,
  RootState,
  WorkOrderModule,
} from '../redux';
import { RouteComponentProps } from 'react-router-dom';
import ProjectOverviewTable, {
  ProjectOverviewTableProps,
  SortTable,
} from '../components/project_overview/project_overview_table';
import { SortTableRowInfo } from '../components/UI/table/sort_table';
import { Config } from '../utils';
import { checkIsBilling, getCustomerPlanInfo } from '../api/stripe';
import { createCrispProfile, getCrispProfile } from '../api/crisp';
import { Crisp } from 'crisp-sdk-web';
import { ConfirmationModal } from '../../src/modals/confirmation_modal';
import { EditItemsModal, EditItemsModalProps, EditValues } from '../modals/edit-items-modal';
import { SearchSelectProps } from '../components/UI/search_select/search_select';
import LoadingModal from '../modals/loading-modal';
import { getRooms } from '../api/room';
import PaginationEndIcon from '../assets/icons/chevron-end.svg';
import PaginationNextIcon from '../assets/icons/chevron-right.svg';
import UserCheckIcon from '../assets/icons/user-check.svg';
import {
  AtSign,
  CircleCheck,
  CirclePlus,
  ClipboardList,
  CreditCard,
  LucideX,
  Mail,
  Search,
  TriangleAlert,
  UserRound,
} from 'lucide-react';
import AddIcon from '../assets/icons/add.svg';
import Confetti from '../assets/icons/confetti.svg';
import PopUpClose from '../assets/icons/pop_up_close.svg';
import { FadeLoader } from 'react-spinners';
import { editWorkOrder, getWorkOrderPDFContent } from '../api/work-order';
import {
  archiveClientProjectItem,
  deleteClientProject,
  draperyOrderCopy,
  editClientProject,
  getAllClients,
  getAllProjects,
  searchClients,
} from '../api/client';
import {
  buyAdditionalSeats,
  changeSubscriptionPlan,
  getAccount,
  getSeatInfo,
  retrieveMetadata,
  updateAccount,
} from '../api/account';
import { getAllInfo, getTotalNumberCount, userCanCreateNewOrder } from '../api/drapery-order';
import { callLambda, getPdfFileNameFromLambdaResponse } from '../api/lambda';
import {
  getMergedPdfPrintUrl,
  isStoredFileMissingError,
  isMergePdfNoneFoundError,
  mergePdfFiles,
  openStoredPdf,
  storeFile,
} from '../api/file-store';
import { WarningModal } from '../modals/warning_modal';
import moment from 'moment';
import { seedItemsOnLogin } from '../api/item';
import { addWorkroomSetting } from '../api/workroom-setting';
import { trackView } from '../components/analytics/track_view';
import { MixpanelEvents } from '../components/analytics/mix_panel_events';
import Filter from '../components/filter/Filter';
import FiltersDrawer from '../components/filters_drawer/FiltersDrawer';
import ColumnVisibilityMenu from '../components/project_overview/column_visibility_menu';
import {
  DEFAULT_PROJECT_OVERVIEW_COLUMN_VISIBILITY,
  PROJECT_OVERVIEW_COLUMNS,
  ProjectOverviewColumnVisibility,
  resolveColumnVisibility,
} from '../components/project_overview/column_visibility';
import { exportEstimate, quickbooksCheckIsConnected } from '../api/quickbooks';
import EstimateBuilderSheet from '../components/estimating/EstimateBuilderSheet';
import { getAllEstimates } from '../api/estimates';
import type { ProjectEstimate } from '../interfaces/project-estimate';
import {
  CustomColumnPreference,
  getColumnVisibilityPreference,
  saveCustomColumnsPreference,
  upsertColumnVisibilityPreference,
} from '../api/column-visibility-preferences';
import { editDraperyOrderSummaryComponent } from '../api/drapery-order-summary-component';
import { regenerateWorkOrderDrawing } from '../helper/regenerate-work-order-drawing';
import { initial_statuses } from '../initials/initials';
import { addNewStatus, getAllStatuses } from '../api/statuses';
import { PopoverScrollContext } from '../ui_components/popover/popover';
import { InputGroup, InputGroupAddon, InputGroupInput } from '../components/UI/input-group';
import { Button } from '../components/ui/button';
import { Checkbox } from '../components/ui/checkbox';
import { Label } from '../components/ui/label';
import { ClientProject } from '../interfaces/client';
import { checkGate } from '../statsig';
import {
  openQuipaAssistant,
  QUIPA_ASSISTANT_CREATE_PROJECT_GATE,
  QUIPA_ASSISTANT_CLOSED_EVENT,
} from '../components/projects/quipa-assistant-events';
import { filterFalsePositivePurchasedGoodsForOverviewSearch } from '../utils/overviewSearch';
import { SEARCH_INPUT_DEBOUNCE_MS } from '../helper/customHooks';
import {
  getQuickBooksOnlineErrorTitle,
  getQuickBooksOnlineNotificationSource,
} from '../helper/quickBooksNotifications';
import { cn } from '@/lib/utils';
import { readCachedPricingPermission } from '../helper/pricingPermission';
import { getAllRolesByAccountId } from '../api/roles';
import { addNewAssignee, editAssignee, getAllAssigneesByAccountId } from '../api/assignees';
import { getUser, inviteMember } from '../api/users';
import {
  buildRoleAssignmentFilterOptions,
  buildRoleAssignmentOptionsByRoleId,
  extractAssigneesForRoleAssignments,
  extractTeamMembersForRoleAssignments,
  getRoleColumnsForTarget,
  resolveRoleAssignmentOwnerAccountId,
  type RoleAssignmentOptionsByRoleId,
  type RoleAssignmentRole,
} from '../helper/roleAssignments';
import WideSheet from '../components/wide_sheet/WideSheet';
import {
  AssigneeWithoutLoginRow,
  collectUsedLabels,
  extractApiErrorMessage,
  extractSeatLimitFromPlanInfo,
  formatTimeAgo,
  generateUniqueAssigneeLabel,
  InvitePanelMode,
  mapAssigneePayloadToRow,
  normalizeAssigneeLabelInput,
  normalizeRoleIds,
  PendingInvitationRow,
  PermissionTooltipKey,
  PRICING_TABLE_PLANS_GATE,
  readOwnerAccountIdFromStorage,
  resolveOwnerAccountIdFromTeamContext,
  RolePermissionRow,
  showErrorToast,
  showSuccessToast,
  showToast,
  TablePermissionTooltipPosition,
  TeamMemberPermissionDraft,
  TeamMemberRow,
} from './team_settings';
import { Input } from '../components/ui/input';
import { ScrollToPosition } from '../containers/application';
import { PageContent } from '../components/content/page_content';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../components/ui/dialog';
import { RadioGroup, RadioGroupItem } from '../components/ui/radio-group';
import PermissionHelpTooltip from '../components/permission_help_tooltip';
import { duplicatePurchasedGood } from '../api/purchased-goods';
import {
  CUSTOM_COLUMN_VISIBILITY_KEY_BY_ID,
  isConfiguredCustomColumn,
  normalizeCustomColumnsConfig,
  writeCustomColumnValue,
  type CustomColumnId,
} from '../components/orderingAndReceiving/custom_columns';
import {
  COLUMN_VISIBILITY_PAGES,
  normalizeAssignmentColumnVisibility,
  normalizeColumnVisibilityPreference,
} from '../helper/columnVisibilityPreference';

const ITEMS_COLUMN_KEYS = PROJECT_OVERVIEW_COLUMNS.map((column) => column.key);

interface OverviewOwnProps extends RouteComponentProps {
  isConnected?: boolean;
}

interface OverviewProps extends OverviewOwnProps {
  accountId: number;
  email: string;
  firstName: string;
  lastName: string;
  ripplefoldPopUp?: number;
}

interface OverviewModalProps extends OverviewOwnProps {
  isOpenModal: boolean;
  handleCloseModal(): void;
  handleOpenSubscriptionPlanModal(): void;
  handleShowBottomSheet(val: boolean, client?: any): void;
  handlePreFill?(payload: any): void;
  handleOpenSinglePurchasedGoods?(val: number | null): void;
  purchasedGoodsRefetch?: boolean;
  accountUser?: any;
  canAccessTeamSettings?: boolean;
  handleUpdateTeamMembers?(items: any[]): void;
  backToTop?: boolean;
  pageScrollTo?(position: ScrollToPosition, val: number): void;
}

interface StateProps {
  showArchived: boolean;
  projectList: ClientDashboardModule.ClientProject[];
  sortValue: { field: string; direction: 'ASC' | 'DESC' };
  roomList: RoomModule.Room[];
  checkedProjects: number[];
  workOrderPdfStatus: 'none' | 'downloading' | 'error';
  isLoadingOpen: boolean;
  accountId: number;
  workOrderPdfContent?: WorkOrderModule.WorkOrderPdfContent;
  isEditItemsModalOpen: boolean;
  isModalOpen: boolean;
  sort: 'asc' | 'desc';
  client?: ClientModule.Client;
  clients: SortTableRowInfo[];
  showModal: string | null;
  isPopUpModalOpen: boolean | undefined;
  value: string;
  isFetched: boolean;
  isEditClientModalOpen: boolean;
  displayContent: boolean;
  areaScrollInfo: {
    scrollX: number;
    scrollY: number;
  };
  pageLimit: number;
  pageNumber: number;
  totalPages: number;
  ordersLength: number;
  searchTerm: any;
  searchHighlightWord: any;
  ripplefoldPopUp?: number;
  hardwarePopUp?: number;
  romanShadePopUp?: number;
  pageLoading: boolean;
  isPopUpChecked: boolean;
  isSubmenuOpened: boolean;
  otherItemPopUp?: number;
  romanShadeCalculationsPopUp?: number;
  duplicateLoading: boolean;
  exportingEstimateLoading: boolean;
  filters: any;
  filtersDraft: any;
  columnVisibility: ProjectOverviewColumnVisibility;
  isEstimateModalOpen: boolean;
  qbEstimateId?: string | null;
  accountStatuses: any;
  refetch: boolean;
  projectRefetch: boolean;
  newStatusFilter: boolean;
  newStatusFilterValue: string;
  remainingItemOrder: number;
  accountIsAdmin: boolean;
  accountCanSeePricing: boolean;
  canCreateOrder: boolean;
  isPrintModalOpen: boolean;
  generatePdf: boolean;
  items: string[];
  isMobile: boolean;
  filter_dropdown?: string;
}

const releaseDate = new Date('2026-01-12');
const thirtyDaysAfterRelease = new Date(releaseDate);
thirtyDaysAfterRelease.setDate(thirtyDaysAfterRelease.getDate() + 30);
const showNewBadge = thirtyDaysAfterRelease > new Date();

const AnnouncementPopup: React.FC<{
  active?: number | boolean;
  className?: string;
  dataQa?: string;
  children: React.ReactNode;
}> = ({ active, className, dataQa, children }) => (
  <div
    data-qa={dataQa}
    className={cn(
      'fixed left-1/2 top-1/2 z-[999] w-[575px] max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white p-6 shadow-[0px_6px_5px_0px_rgba(0,0,0,0.3),0px_10px_14px_8px_rgba(0,0,0,0.15)] transition-transform duration-150',
      active ? 'scale-100' : 'scale-0',
      className
    )}
  >
    {children}
  </div>
);

const paginationSelectClassName =
  'h-9 rounded-md border border-input bg-white px-3 pr-8 text-sm shadow-xs focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]';

const ALL_ITEMS_OPTION = 'All Items';

const isAllItemsOption = (value: string) => value.trim().toLowerCase() === 'all items';

const buildItemTypeFilterOptions = (items: string[] = []) => {
  let romanShade: string | null = null;
  let drapery: string | null = null;
  const remaining: string[] = [];

  items.forEach((item) => {
    if (typeof item !== 'string') return;
    const trimmed = item.trim();
    if (!trimmed) return;
    if (isAllItemsOption(trimmed)) return;
    const normalized = trimmed.toLowerCase();
    if (normalized === 'roman shade') {
      if (!romanShade) {
        romanShade = trimmed;
      } else {
        remaining.push(trimmed);
      }
      return;
    }
    if (normalized === 'drapery') {
      if (!drapery) {
        drapery = trimmed;
      } else {
        remaining.push(trimmed);
      }
      return;
    }
    remaining.push(trimmed);
  });

  const ordered = [ALL_ITEMS_OPTION];
  if (romanShade) ordered.push(romanShade);
  if (drapery) ordered.push(drapery);
  ordered.push(...remaining);

  const unique: string[] = [];
  const seen = new Set<string>();
  ordered.forEach((item) => {
    const key = item.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    unique.push(item);
  });

  return unique;
};

let initialSeatState = {
  interval: 'month',
  quantity: '1',
  cost: '0.00',
};

export const OverviewPage = (
  props: OverviewProps & OverviewModalProps & DispatchProp
): JSX.Element => {
  const propsRef = useRef(props);
  const [state, setState] = useState<StateProps>(() => {
    const initialPageLimit =
      typeof window !== 'undefined' && window.localStorage.getItem('paginationLimit')
        ? Number(window.localStorage.getItem('paginationLimit'))
        : 25;
    const initialIsMobile = typeof window !== 'undefined' ? window.innerWidth <= 768 : false;

    return {
      showArchived: false,
      projectList: [],
      sortValue: { field: '', direction: 'ASC' },
      roomList: [
        {
          id: 0,
          name: 'Please select',
          description: '',
        },
      ],
      checkedProjects: [],
      workOrderPdfStatus: 'none',
      isLoadingOpen: false,
      accountId: 0,
      isEditItemsModalOpen: false,
      isModalOpen: false,
      sort: 'asc',
      clients: [],
      showModal: '',
      isPopUpModalOpen: true,
      value: '',
      isFetched: true,
      isEditClientModalOpen: false,
      displayContent: false,
      areaScrollInfo: {
        scrollX: 0,
        scrollY: 0,
      },
      pageLimit: initialPageLimit,
      pageNumber: 1,
      totalPages: 0,
      ordersLength: 0,
      searchTerm: '',
      searchHighlightWord: '',
      ripplefoldPopUp: 0,
      hardwarePopUp: 0,
      romanShadePopUp: 0,
      pageLoading: true,
      isPopUpChecked: false,
      isSubmenuOpened: false,
      otherItemPopUp: 0,
      romanShadeCalculationsPopUp: 0,
      duplicateLoading: false,
      exportingEstimateLoading: false,
      filters: {
        client: { value: [], archived: false },
        status: { value: [] },
        estimate: { value: [] },
        invoice: { value: [] },
        items: { value: [] },
        assignee: { value: [] },
      },
      filtersDraft: {
        client: { value: [], archived: false },
        status: { value: [] },
        estimate: { value: [] },
        invoice: { value: [] },
        items: { value: [] },
        assignee: { value: [] },
      },
      columnVisibility: DEFAULT_PROJECT_OVERVIEW_COLUMN_VISIBILITY,
      isEstimateModalOpen: false,
      qbEstimateId: '',
      accountStatuses: initial_statuses,
      refetch: false,
      projectRefetch: false,
      newStatusFilter: false,
      newStatusFilterValue: '',
      remainingItemOrder: 0,
      accountIsAdmin: false,
      accountCanSeePricing: readCachedPricingPermission(false),
      canCreateOrder: true,
      isPrintModalOpen: false,
      generatePdf: false,
      items: [],
      isMobile: initialIsMobile,
      filter_dropdown: '',
    };
  });
  const initialOverviewLoadAccountIdRef = useRef<number | null>(null);
  const didTrackOverviewViewRef = useRef(false);
  const loadedColumnVisibilityAccountIdRef = useRef<number | null>(null);
  const projectsRequestRef = useRef<{ key: string; promise: Promise<void> } | null>(null);
  const clientsRequestRef = useRef<{ key: string; promise: Promise<void> } | null>(null);
  const roomsRequestRef = useRef<Promise<any> | null>(null);
  const rolesRequestRef = useRef<{ accountId: number; promise: Promise<any[]> } | null>(null);
  const assigneesRequestRef = useRef<{ accountId: number; promise: Promise<any[]> } | null>(null);
  const seatUsageRequestRef = useRef<{ accountId: number; promise: Promise<void> } | null>(null);
  const firstName = (localStorage.getItem('firstName') || '').trim();
  const lastName = (localStorage.getItem('lastName') || '').trim();
  const [roleAssignmentColumns, setRoleAssignmentColumns] = useState<RoleAssignmentRole[]>([]);
  const [roleColumnVisibility, setRoleColumnVisibility] = useState<Record<number, boolean>>({});
  const [unsetRoleColumns, setUnsetRoleColumns] = useState<RoleAssignmentRole[]>([]);
  const [customColumnsConfig, setCustomColumnsConfig] = useState<CustomColumnPreference[]>([]);
  const normalizedCustomColumns = useMemo(
    () => normalizeCustomColumnsConfig(customColumnsConfig),
    [customColumnsConfig]
  );
  const [account, setAccount] = useState<any>(null);
  const [estimateSheetState, setEstimateSheetState] = useState<{
    open: boolean;
    estimateId: number | null;
    client: any | null;
    estimates: ProjectEstimate[];
    qboConnected: boolean;
  }>({
    open: false,
    estimateId: null,
    client: null,
    estimates: [],
    qboConnected: false,
  });
  const [refetchRoles, setRefetchRoles] = useState<boolean>(false);
  // ADD TEAM MEMBER WIDE SHEET
  // @ts-ignore
  const [accountIsOwner, setAccountIsOwner] = useState(false);
  const canManageTeamMembers = accountIsOwner || account?.isAdmin;
  const canUseRoleAssignments = props.canAccessTeamSettings === true;
  const canCustomizeCustomColumns = !!account?.isOwner || !!account?.isAdmin;
  const visibleCustomColumns = useMemo(
    () =>
      canCustomizeCustomColumns
        ? normalizedCustomColumns
        : normalizedCustomColumns.filter((column) => isConfiguredCustomColumn(column)),
    [canCustomizeCustomColumns, normalizedCustomColumns]
  );
  const hiddenColumnKeys = useMemo(
    () =>
      canCustomizeCustomColumns
        ? []
        : normalizedCustomColumns
            .filter((column) => !isConfiguredCustomColumn(column))
            .map((column) => CUSTOM_COLUMN_VISIBILITY_KEY_BY_ID[column.id as CustomColumnId]),
    [canCustomizeCustomColumns, normalizedCustomColumns]
  );
  const [isInvitePanelOpen, setIsInvitePanelOpen] = useState(false);
  const [openPermissionTooltip, setOpenPermissionTooltip] = useState<PermissionTooltipKey | null>(
    null
  );
  const [invitePanelMode, setInvitePanelMode] = useState<InvitePanelMode>('team_member');
  const [usedSlots, setUsedSlots] = useState(0);
  const [availableSlots, setAvailableSlots] = useState(0);
  const normalizedAvailableSlots = Math.max(availableSlots, 0);
  const isSeatLimitReached = usedSlots >= normalizedAvailableSlots;
  const [isInvitingMember, setIsInvitingMember] = useState(false);
  const [memberEmail, setMemberEmail] = useState('');
  const [memberSelectedRoleIds, setMemberSelectedRoleIds] = useState<number[]>([]);
  const [memberPricingAccess, setMemberPricingAccess] = useState(false);
  const [memberAdminAccess, setMemberAdminAccess] = useState(false);
  const [assigneeName, setAssigneeName] = useState('');
  const [teamScopeAccountId, setTeamScopeAccountId] = useState(props.accountUser?.teamContext?.owner?.accountId || propsRef?.current?.accountId);
  const [assigneeLabel, setAssigneeLabel] = useState('');
  const [assigneeSelectedRoleIds, setAssigneeSelectedRoleIds] = useState<number[]>([]);
  const [teamMembers, setTeamMembers] = useState<any[]>(
    props.accountUser?.teamContext?.teamMembers || []
  );
  useEffect(() => {
    setTeamMembers(props.accountUser?.teamContext?.teamMembers || []);
  }, [props.accountUser?.teamContext?.teamMembers]);
  const ownerTeamMemberAccountId = teamMembers.find((member) => member.isOwner)?.accountId || 0;
  const ownerAccountIdFromStorage = readOwnerAccountIdFromStorage();
  const managedAccountId = teamScopeAccountId || propsRef?.current?.accountId;
  const assigneeScopeAccountId =
    ownerTeamMemberAccountId || ownerAccountIdFromStorage || managedAccountId;
  const [assigneeMutationState, setAssigneeMutationState] = useState<
    null | 'adding' | 'editing' | 'deleting'
  >(null);
  const [assigneesWithoutLogin, setAssigneesWithoutLogin] = useState<AssigneeWithoutLoginRow[]>([]);
  // @ts-ignore
  const [teamMemberPermissionBaseline, setTeamMemberPermissionBaseline] = useState<
    Record<string, TeamMemberPermissionDraft>
  >({});
  // @ts-ignore
  const [pendingTeamMemberPermissions, setPendingTeamMemberPermissions] = useState<
    Record<string, TeamMemberPermissionDraft>
  >({});
  // @ts-ignore
  const [ownerEmail, setOwnerEmail] = useState('');
  // @ts-ignore
  const [pendingSlots, setPendingSlots] = useState(0);
  const [pendingInvitations, setPendingInvitations] = useState<PendingInvitationRow[]>([]);
  // @ts-ignore
  const [planName, setPlanName] = useState('');
  const assignmentOptionsByRoleId = useMemo<RoleAssignmentOptionsByRoleId>(() => {
    if (!canUseRoleAssignments) {
      return {};
    }

    return buildRoleAssignmentOptionsByRoleId(
      roleAssignmentColumns,
      extractTeamMembersForRoleAssignments({ teamMembers }),
      extractAssigneesForRoleAssignments(assigneesWithoutLogin)
    );
  }, [assigneesWithoutLogin, canUseRoleAssignments, roleAssignmentColumns, teamMembers]);
  const isAssigneeMutationLoading = assigneeMutationState !== null;
  const canSubmitInvitePanel =
    invitePanelMode === 'team_member'
      ? memberEmail.trim().length > 0 && !isSeatLimitReached && !isInvitingMember
      : assigneeName.trim().length > 0 &&
        assigneeLabel.trim().length > 0 &&
        assigneeSelectedRoleIds.length > 0 &&
        !isAssigneeMutationLoading;
  const [isAssigneeLabelAuto, setIsAssigneeLabelAuto] = useState(true);
  const [roles, setRoles] = useState<RolePermissionRow[]>([]);
  const [isRemovingInactiveMembers, setIsRemovingInactiveMembers] = useState(false);
  // @ts-ignore
  const [resendingInvitationId, setResendingInvitationId] = useState<string | null>(null);
  // @ts-ignore
  const [deletingInvitationId, setDeletingInvitationId] = useState<string | null>(null);
  const seatUsagePercent = normalizedAvailableSlots
    ? Math.min((Math.max(usedSlots, 0) / normalizedAvailableSlots) * 100, 100)
    : 0;
  const remainingSeatsAfterInvite = Math.max(normalizedAvailableSlots - (usedSlots + 1), 0);
  // @ts-ignore
  const [openTablePermissionTooltip, setOpenTablePermissionTooltip] =
    useState<PermissionTooltipKey | null>(null);
  // @ts-ignore
  const [tablePermissionTooltipPosition, setTablePermissionTooltipPosition] =
    useState<TablePermissionTooltipPosition | null>(null);
  const [openSeatsModal, setOpenSeatsModal] = useState(false);
  const [seatState, setSeatState] = useState(initialSeatState);
  const [availableSeats, setAvailableSeats] = useState<any>(null);
  const [seatLoading, setSeatLoading] = useState<boolean>(false);
  // END OF ADD TEAM MEMBER WIDE SHEET

  const updateState = useCallback(
    (patch: Partial<StateProps> | ((prev: StateProps) => Partial<StateProps>)) => {
      setState((prev) => {
        const nextPatch = typeof patch === 'function' ? patch(prev) : patch;
        if (!nextPatch || Object.keys(nextPatch).length === 0) {
          return prev;
        }
        const hasChanges = Object.entries(nextPatch).some(
          ([key, value]) => (prev as any)[key] !== value
        );
        if (!hasChanges) {
          return prev;
        }
        return { ...prev, ...nextPatch };
      });
    },
    []
  );

  const loadColumnVisibilityPreference = useCallback(async () => {
    const accountId = Number(props.accountId || 0);
    if (!accountId || loadedColumnVisibilityAccountIdRef.current === accountId) {
      return;
    }

    loadedColumnVisibilityAccountIdRef.current = accountId;

    try {
      const preference = await getColumnVisibilityPreference({
        accountId,
        page: COLUMN_VISIBILITY_PAGES.items,
      });
      updateState({
        columnVisibility: resolveColumnVisibility(
          normalizeColumnVisibilityPreference(ITEMS_COLUMN_KEYS, preference?.visibility?.columns)
        ),
      });
      setRoleColumnVisibility(
        normalizeAssignmentColumnVisibility(preference?.visibility?.assignmentColumns)
      );
      setCustomColumnsConfig(
        Array.isArray(preference?.visibility?.customColumns)
          ? preference.visibility.customColumns
          : []
      );
    } catch (error) {
      loadedColumnVisibilityAccountIdRef.current = null;
      console.error('Failed to load column visibility preferences for items page:', error);
    }
  }, [props.accountId, updateState]);

  const stateRef = useRef(state);
  useEffect(() => {
    stateRef.current = state;
  }, [state]);

  useEffect(() => {
    void loadColumnVisibilityPreference();
  }, [loadColumnVisibilityPreference]);

  useEffect(() => {
    propsRef.current = props;
  }, [props]);

  const searchInputRef = useRef<HTMLInputElement>(null);
  const submenuRef = useRef<HTMLDivElement>(null);
  const newStatusRef = useRef<HTMLInputElement>(null);
  const debounceTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleSetNewBadgeTab = useCallback((ttl: number, value: string, key: string): void => {
    if (typeof window !== 'undefined') {
      const newDate = new Date();
      const now = newDate.getTime();
      const item = {
        value,
        expiry: now + ttl,
      };
      window.localStorage.setItem(key, JSON.stringify(item));
    }
  }, []);

  const handleResize = useCallback(() => {
    if (typeof window === 'undefined') return;
    const isMobile = window.innerWidth <= 768;
    updateState((prev) => (prev.isMobile === isMobile ? {} : { isMobile }));
  }, [updateState]);

  const handleClickOutside = useCallback(
    (event: MouseEvent): void => {
      if (!stateRef.current.isSubmenuOpened) return;
      if (submenuRef.current && !submenuRef.current.contains(event.target as Node)) {
        updateState({ isSubmenuOpened: false });
      }
    },
    [updateState]
  );

  const handleFindGrandParent = useCallback((client: any): any => {
    if (client.parentClient) {
      return handleFindGrandParent(client.parentClient);
    }
    return client;
  }, []);

  const loadProjects = useCallback(
    async (
      overrides?: Partial<
        Pick<
          StateProps,
          'showArchived' | 'sortValue' | 'pageLimit' | 'pageNumber' | 'searchTerm' | 'filters'
        >
      >
    ) => {
      const current = stateRef.current;
      const showArchived = overrides?.showArchived ?? current.showArchived;
      const sort = overrides?.sortValue ?? current.sortValue;
      const pageLimit = overrides?.pageLimit ?? current.pageLimit;
      const pageNumber = overrides?.pageNumber ?? current.pageNumber;
      const searchTerm = overrides?.searchTerm ?? current.searchTerm;
      const filters = overrides?.filters ?? current.filters;

      const filtersPayload = {
        client: filters.client.value,
        status: filters.status.value,
        estimate: filters.estimate.value,
        invoice: filters.invoice.value,
        items: filters.items.value,
        assignee: canUseRoleAssignments ? filters.assignee.value : [],
      };

      const accountId = parseFloat(localStorage.getItem('accountId') || '0');
      if (!accountId) {
        updateState({ pageLoading: false });
        return;
      }

      const requestKey = JSON.stringify({
        accountId,
        showArchived,
        sort,
        pageLimit,
        pageNumber,
        searchTerm,
        filtersPayload,
      });
      if (projectsRequestRef.current?.key === requestKey) {
        return projectsRequestRef.current.promise;
      }

      const request = (async () => {
        updateState({ pageLoading: true });

        try {
          const getProjectsRes = await getAllProjects(
            accountId,
            showArchived,
            sort,
            pageLimit,
            pageNumber,
            searchTerm,
            filtersPayload
          );

          if (!getProjectsRes || getProjectsRes.error) {
            updateState({ pageLoading: false });
            return;
          }

          const projectList: ClientDashboardModule.ClientProject[] =
            filterFalsePositivePurchasedGoodsForOverviewSearch(
              Array.isArray(getProjectsRes.result) ? getProjectsRes.result : [],
              searchTerm
            );
          let roomList = current.roomList;
          if (roomList.length <= 1) {
            if (!roomsRequestRef.current) {
              roomsRequestRef.current = getRooms().finally(() => {
                roomsRequestRef.current = null;
              });
            }
            const getRoomListRes = await roomsRequestRef.current;
            if (getRoomListRes?.error) {
              updateState({ pageLoading: false });
              return;
            }
            roomList = [...roomList, ...(Array.isArray(getRoomListRes) ? getRoomListRes : [])];
          }

          if (projectList && projectList.length > 0) {
            for (const p of projectList) {
              const mainParent = handleFindGrandParent(p.client);
              p.mainParent = mainParent.id === p.clientId ? null : mainParent;
            }
          }

          updateState({
            projectList,
            roomList,
            isFetched: false,
            totalPages: getProjectsRes.totalPages,
            ordersLength: getProjectsRes.ordersLength,
            searchHighlightWord: searchTerm,
            pageLoading: false,
            items: getProjectsRes.itemNames,
          });

          if (searchInputRef.current) {
            searchInputRef.current.focus();
          }
        } catch (error) {
          console.error('Failed to load overview projects:', error);
          updateState({ pageLoading: false });
        } finally {
          if (projectsRequestRef.current?.key === requestKey) {
            projectsRequestRef.current = null;
          }
        }
      })();

      projectsRequestRef.current = { key: requestKey, promise: request };
      return request;
    },
    [canUseRoleAssignments, handleFindGrandParent, updateState]
  );

  const loadEstimatesForClient = useCallback(async (clientId: number): Promise<ProjectEstimate[]> => {
    const accountId = Number(propsRef.current.accountId || 0);
    const normalizedClientId = Number(clientId || 0);
    if (!accountId || !normalizedClientId) return [];

    const response = await getAllEstimates({
      clientId: normalizedClientId,
      accountId,
    });
    return Array.isArray(response) ? (response as ProjectEstimate[]) : [];
  }, []);

  const loadQuickBooksConnectionState = useCallback(async () => {
    const accountId = Number(propsRef.current.accountId || 0);
    if (!accountId) return false;
    try {
      const response = await quickbooksCheckIsConnected(accountId);
      return response?.connected === true && !!response?.userinfo;
    } catch (error) {
      console.error('Failed to check QuickBooks connection:', error);
      return !!propsRef.current.isConnected;
    }
  }, []);

  const resolveEstimateClient = useCallback((estimateId: number, estimate?: any) => {
    if (estimate?.client?.id) return estimate.client;
    const matchingProject = stateRef.current.projectList.find((project: any) => {
      const estimates = project?.estimateStatusSummary?.estimates || [];
      return estimates.some((item: any) => Number(item?.estimateId || 0) === Number(estimateId));
    });
    return matchingProject?.client || null;
  }, []);

  const handleOpenEstimateFromStatus = useCallback(
    async (estimateId: number, estimate?: any) => {
      if (!stateRef.current.accountCanSeePricing) return;

      const normalizedEstimateId = Number(estimateId || 0);
      const client = resolveEstimateClient(normalizedEstimateId, estimate);
      const normalizedClientId = Number(client?.id || 0);
      if (!Number.isInteger(normalizedEstimateId) || normalizedEstimateId <= 0 || !normalizedClientId) {
        return;
      }

      try {
        const [estimates, qboConnected] = await Promise.all([
          loadEstimatesForClient(normalizedClientId),
          loadQuickBooksConnectionState(),
        ]);
        setEstimateSheetState({
          open: true,
          estimateId: normalizedEstimateId,
          client,
          estimates,
          qboConnected,
        });
      } catch (error) {
        console.error('Failed to load estimate from status link:', error);
        setEstimateSheetState({
          open: true,
          estimateId: normalizedEstimateId,
          client,
          estimates: [],
          qboConnected: !!propsRef.current.isConnected,
        });
      }
    },
    [loadEstimatesForClient, loadQuickBooksConnectionState, resolveEstimateClient]
  );

  const handleEstimateSheetChanged = async () => {
    await loadProjects();
    const activeClientId = Number(estimateSheetState.client?.id || 0);
    if (!activeClientId) return;

    try {
      const estimates = await loadEstimatesForClient(activeClientId);
      setEstimateSheetState((prev) => ({ ...prev, estimates }));
    } catch (error) {
      console.error('Failed to refresh estimates after estimate change:', error);
    }
  };

  const handleCloseEstimateSheet = () => {
    setEstimateSheetState((prev) => ({
      ...prev,
      open: false,
      estimateId: null,
    }));
  };

  const loadClients = useCallback(async (): Promise<void> => {
    const accountId = Number(propsRef.current.accountId || 0);
    if (!accountId) {
      return;
    }

    const sortValue = stateRef.current.sort.toUpperCase();
    const requestKey = `${accountId}:${sortValue}`;
    if (clientsRequestRef.current?.key === requestKey) {
      return clientsRequestRef.current.promise;
    }

    const request = (async () => {
      const res = await getAllClients({
        accountId,
        sort: { column: 'displayName', value: sortValue },
        includeInactive: true,
      });

      if (res && !res.error) {
        const convertToSortTableRowInfo = (client: ClientModule.BasicClientInfo) => {
          const rowInfo: SortTableRowInfo = client;
          if (client.subClients) {
            rowInfo.subList = client.subClients.map(convertToSortTableRowInfo);
          }
          return rowInfo;
        };

        const clients = res.map(convertToSortTableRowInfo);
        const allSubClients = clients.reduce(
          (acc: any, client: any) => acc.concat(client.subList || []),
          [] as SortTableRowInfo[]
        );

        const updatedClients = [...clients, ...allSubClients];

        updateState({
          clients: updatedClients,
        });
      }
    })().finally(() => {
      if (clientsRequestRef.current?.key === requestKey) {
        clientsRequestRef.current = null;
      }
    });

    clientsRequestRef.current = { key: requestKey, promise: request };
    return request;
  }, [updateState]);

  const loadRolesForAccount = useCallback((accountId: number): Promise<any[]> => {
    const normalizedAccountId = Number(accountId || 0);
    if (!normalizedAccountId) {
      return Promise.resolve([]);
    }

    if (rolesRequestRef.current?.accountId === normalizedAccountId) {
      return rolesRequestRef.current.promise;
    }

    const request = getAllRolesByAccountId({ accountId: normalizedAccountId }).finally(() => {
      if (rolesRequestRef.current?.accountId === normalizedAccountId) {
        rolesRequestRef.current = null;
      }
    });
    rolesRequestRef.current = { accountId: normalizedAccountId, promise: request };
    return request;
  }, []);

  const loadAssigneesForAccount = useCallback((accountId: number): Promise<any[]> => {
    const normalizedAccountId = Number(accountId || 0);
    if (!normalizedAccountId) {
      return Promise.resolve([]);
    }

    if (assigneesRequestRef.current?.accountId === normalizedAccountId) {
      return assigneesRequestRef.current.promise;
    }

    const request = getAllAssigneesByAccountId({ accountId: normalizedAccountId }).finally(() => {
      if (assigneesRequestRef.current?.accountId === normalizedAccountId) {
        assigneesRequestRef.current = null;
      }
    });
    assigneesRequestRef.current = { accountId: normalizedAccountId, promise: request };
    return request;
  }, []);

  const loadRoleAssignmentConfig = useCallback(async (): Promise<void> => {
    if (!canUseRoleAssignments) {
      setRoleAssignmentColumns([]);
      setUnsetRoleColumns([]);
      return;
    }

    const { accountId } = propsRef.current;
    if (!accountId) {
      setRoleAssignmentColumns([]);
      setUnsetRoleColumns([]);
      return;
    }

    try {
      // const user = await getUser({ accountId, includeTeamData: true });
      const user = props.accountUser;
      const teamContext = user?.teamContext || {};
      const ownerAccountId = resolveRoleAssignmentOwnerAccountId(accountId, teamContext);
      const [rolesResponse, assigneesResponse] = await Promise.all([
        loadRolesForAccount(ownerAccountId),
        loadAssigneesForAccount(ownerAccountId),
      ]);

      const columns = getRoleColumnsForTarget(rolesResponse, 'items');
      const unsetRoleColumns: any[] =
        rolesResponse?.filter((i: any) => i && i.items === false) || [];

      setRoleAssignmentColumns(columns);
      setAssigneesWithoutLogin((assigneesResponse || []).map(mapAssigneePayloadToRow));
      setUnsetRoleColumns(unsetRoleColumns);
    } catch (error) {
      console.error('Failed to load role assignments config for items overview:', error);
      setRoleAssignmentColumns([]);
      setUnsetRoleColumns([]);
    }
  }, [
    canUseRoleAssignments,
    loadAssigneesForAccount,
    loadRolesForAccount,
    props.accountUser?.teamContext?.owner?.accountId,
    props.accountUser?.teamContext?.ownerAccountId,
    refetchRoles,
  ]);

  useEffect(() => {
    setRoleColumnVisibility((prev) => {
      if (roleAssignmentColumns.length === 0) {
        return {};
      }
      const next: Record<number, boolean> = {};
      roleAssignmentColumns.forEach((role) => {
        next[role.id] = prev[role.id] !== false;
      });
      return next;
    });
  }, [roleAssignmentColumns]);

  const handleAssistantClosed = useCallback(
    (_event?: Event) => {
      void loadClients();
      void loadProjects();
    },
    [loadClients, loadProjects]
  );

  const handleGetAllStatuses = useCallback(async () => {
    const { accountId } = propsRef.current;

    if (!accountId) {
      console.error('Account ID is missing.');
      return;
    }

    const payload = {
      accountId: accountId,
    };

    const res = await getAllStatuses(payload);
    if (res && !res.error) {
      const mapped_res =
        res && res.length > 0
          ? res.map((s: any) => {
              return {
                ...s,
                value: s.name,
              };
            })
          : [];
      updateState({
        accountStatuses: [...mapped_res, ...initial_statuses],
      });
    }
  }, [updateState]);

  useEffect(() => {
    if (!didTrackOverviewViewRef.current) {
      didTrackOverviewViewRef.current = true;
      trackView(MixpanelEvents.DASHBOARD, {});
    }

    handleResize();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
      window.addEventListener(QUIPA_ASSISTANT_CLOSED_EVENT, handleAssistantClosed);
    }
    document.addEventListener('mousedown', handleClickOutside);

    const showModal = localStorage.getItem('showModal');
    updateState({ showModal: showModal });

    const run = async () => {
      const accountId = Number(propsRef.current.accountId || 0);
      if (!accountId || initialOverviewLoadAccountIdRef.current === accountId) {
        return;
      }
      initialOverviewLoadAccountIdRef.current = accountId;

      const can_create_order = await userCanCreateNewOrder(accountId);
      updateState({ canCreateOrder: can_create_order });
      void handleGetAllStatuses();

      const duplicate = localStorage.getItem('duplicate');
      if (duplicate) {
        const { orderType, id } = JSON.parse(duplicate);
        await deleteClientProject({
          id: Number(id),
          duplicateNotSaved: true,
        } as unknown as ClientProject);
        localStorage.removeItem('duplicate');

        const canCreateOrder = await userCanCreateNewOrder(propsRef?.current?.accountId);
        if (
          !canCreateOrder &&
          stateRef.current.remainingItemOrder >= 0 &&
          orderType !== 'custom-order'
        ) {
          await updateAccount({
            accountId: propsRef?.current?.accountId,
            remainingItemOrder: stateRef.current.remainingItemOrder + 1,
          });
        }
      }

      let account: any;

      try {
        if (accountId) {
          const res = await getAccount(accountId);
          setAccount(res);
          if (res && 'isModalOpen' in res)
            updateState({
              isPopUpModalOpen: res.isModalOpen,
            });
          updateState({
            remainingItemOrder: res.remainingItemOrder,
            accountIsAdmin: !!res.isAdmin,
            accountCanSeePricing: !!res.canSeePricing,
          });
          account = res;
          if (!res.isModalOpen && stateRef.current.showModal === 'true') {
            trackView(MixpanelEvents.POPUPS_REQUIRED, {});
          }
        }
      } catch (error) {
        console.log(error);
      }

      try {
        let profile: any;
        if (accountId) {
          await checkIsBilling(accountId);
          await createCrispProfile(accountId);
          profile = await getCrispProfile(accountId);
        }

        if (profile) {
          Crisp.user.setEmail(profile.email);
          Crisp.user.setNickname(`${profile.person.nickname}`);
        }
      } catch (error) {
        console.error('An error occurred during component mounting:', error);
      } finally {
        void loadClients();
        void loadProjects();
      }

      if (account && (account.ripplefoldPopUp === 0 || !account.ripplefoldPopUp)) {
        await updateAccount({
          accountId: accountId,
          ripplefoldPopUp: 1,
        });

        updateState({
          ripplefoldPopUp: 1,
        });

        handleSetNewBadgeTab(30 * 24 * 60 * 60 * 1000, 'New Tab Badge', 'new_tab_badge');
      } else {
        updateState({
          ripplefoldPopUp: 0,
        });
      }

      if (account && (account.hardwarePopUp === 0 || !account.hardwarePopUp)) {
        await updateAccount({
          accountId: accountId,
          hardwarePopUp: 1,
        });

        updateState({
          hardwarePopUp: 1,
        });

        handleSetNewBadgeTab(30 * 24 * 60 * 60 * 1000, 'New Tab Badge', 'new_tab_badge');
      } else {
        updateState({
          hardwarePopUp: 0,
        });
      }

      if (account && (account.otherItemPopUp === 0 || !account.otherItemPopUp)) {
        await updateAccount({
          accountId: accountId,
          otherItemPopUp: 1,
        });
        updateState({
          otherItemPopUp: 1,
        });
      } else {
        updateState({
          otherItemPopUp: 0,
        });
      }

      if (account && (account.romanShadePopUp === 0 || !account.romanShadePopUp)) {
        await updateAccount({
          accountId: accountId,
          romanShadePopUp: 1,
        });
        updateState({
          romanShadePopUp: 1,
        });
      } else {
        updateState({
          romanShadePopUp: 0,
        });
      }

      if (
        account &&
        (account.romanShadeCalculationsPopUp === 0 || !account.romanShadeCalculationsPopUp)
      ) {
        await updateAccount({
          accountId: accountId,
          romanShadeCalculationsPopUp: 1,
        });
        updateState({
          romanShadeCalculationsPopUp: 1,
        });
      } else {
        updateState({
          romanShadeCalculationsPopUp: 0,
        });
      }
    };

    void run();

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      if (typeof window !== 'undefined') {
        window.removeEventListener(QUIPA_ASSISTANT_CLOSED_EVENT, handleAssistantClosed);
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [
    handleAssistantClosed,
    handleClickOutside,
    handleGetAllStatuses,
    handleResize,
    handleSetNewBadgeTab,
    loadClients,
    loadProjects,
    props.accountId,
    updateState,
  ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      updateState({ displayContent: true });
    }, 100);
    return () => clearTimeout(timer);
  }, [updateState]);

  useEffect(() => {
    void loadRoleAssignmentConfig();
  }, [props.accountId, loadRoleAssignmentConfig]);

  const didMountLoadProjectsRef = useRef(false);
  useEffect(() => {
    if (!didMountLoadProjectsRef.current) {
      didMountLoadProjectsRef.current = true;
      return;
    }

    void loadProjects();
  }, [
    state.sortValue,
    state.pageLimit,
    state.pageNumber,
    state.filters,
    props.purchasedGoodsRefetch,
    state.projectRefetch,
    loadProjects,
  ]);

  const prevItemsRef = useRef<string[] | null>(null);
  useEffect(() => {
    const prevItems = prevItemsRef.current;
    prevItemsRef.current = state.items;

    if (prevItems === state.items) {
      return;
    }

    if (state.items.length > 0 && state.filters.items.value.length > 0) {
      let all_exist = true;
      const set_1 = new Set(state.items);
      all_exist = state.filters.items.value.every((i: any) => set_1.has(i));
      if (!all_exist) {
        updateState((prev) => ({
          filters: {
            ...prev.filters,
            items: { value: prev.filters.items.value.filter((f: any) => set_1.has(f)) },
          },
          filtersDraft: {
            ...prev.filtersDraft,
            items: { value: prev.filtersDraft.items.value.filter((f: any) => set_1.has(f)) },
          },
        }));
      }
    }
  }, [state.items, state.filters.items.value, updateState]);

  const didMountNewStatusRef = useRef(false);
  useEffect(() => {
    if (!didMountNewStatusRef.current) {
      didMountNewStatusRef.current = true;
      return;
    }

    if (state.newStatusFilter) {
      newStatusRef.current?.focus();
    }
  }, [state.newStatusFilter]);

  const didMountRefetchRef = useRef(false);
  useEffect(() => {
    if (!didMountRefetchRef.current) {
      didMountRefetchRef.current = true;
      return;
    }

    void handleGetAllStatuses();
  }, [state.refetch, handleGetAllStatuses]);

  const didMountSearchRef = useRef(false);
  useEffect(() => {
    if (!didMountSearchRef.current) {
      didMountSearchRef.current = true;
      return;
    }

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      if (stateRef.current.pageNumber !== 1) {
        updateState({ pageNumber: 1 });
        return;
      }
      void loadProjects({
        pageNumber: 1,
        searchTerm: stateRef.current.searchTerm,
      });
    }, SEARCH_INPUT_DEBOUNCE_MS);

    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, [state.searchTerm, loadProjects, updateState]);

  useEffect(() => {
    if (state.projectList && state.projectList.length < 1 && state.pageNumber > 1) {
      updateState((prev) => ({
        pageNumber: prev.totalPages,
      }));
    }
  }, [state.projectList, state.pageNumber, updateState]);

  const handleChangeNewStatusFilter = (e: ChangeEvent<HTMLInputElement>) => {
    updateState({ newStatusFilterValue: e.target.value });
  };

  const handleSetNewStatusFilter = () => {
    if (!stateRef.current.newStatusFilterValue) {
      updateState((prev) => ({ newStatusFilter: !prev.newStatusFilter }));
    }
  };

  const handleSaveNewStatus = async () => {
    if (stateRef.current.newStatusFilterValue && stateRef.current.newStatusFilterValue.trim()) {
      const accountId = localStorage.getItem('accountId');
      const payload: { accountId?: number; name: string } = {
        name: stateRef.current.newStatusFilterValue,
      };
      if (accountId) {
        const parsedAccountId = JSON.parse(accountId);
        payload['accountId'] = parsedAccountId;
      }
      const res = await addNewStatus(payload);
      if (res && !res.error) {
        updateState({
          newStatusFilterValue: '',
          newStatusFilter: false,
        });

        handleTriggerRefetch();
      } else {
        console.error(res.error, res.message);
      }
    }
  };

  const handlePageLimitChange = (e: ChangeEvent<HTMLSelectElement>): void => {
    const { value } = e.currentTarget;

    const numberValue = Number(value);

    if (isNaN(numberValue)) {
      return;
    }

    if (typeof window !== 'undefined') {
      window.localStorage.setItem('paginationLimit', value);
    }

    updateState({
      pageNumber: 1,
      pageLimit: numberValue,
    });
  };

  const handleNextPage = (): void => {
    updateState((prev) => ({
      pageNumber: prev.pageNumber + 1,
    }));
  };

  const handlePrevPage = (): void => {
    if (stateRef.current.pageNumber <= 1) {
      return;
    }
    updateState((prev) => ({
      pageNumber: prev.pageNumber - 1,
    }));
  };

  const handleFirstPage = (): void => {
    updateState({
      pageNumber: 1,
    });
  };

  const handleLastPage = (): void => {
    updateState((prev) => ({
      pageNumber: prev.totalPages,
    }));
  };

  const checkAllRows = (checked: boolean) => {
    const current = stateRef.current;
    updateState({
      checkedProjects: checked ? current.projectList.map((p) => p.itemId) : [],
    });
  };

  const checkRow = (id: number, checked: boolean) => {
    const current = stateRef.current;
    if (checked) {
      if (current.checkedProjects.includes(id)) {
        return;
      }
      updateState({
        checkedProjects: [...current.checkedProjects, id],
      });
    } else {
      updateState({
        checkedProjects: current.checkedProjects.filter((cid) => cid !== id),
      });
    }
  };

  const handleNotCheckedBatchRow = (id: number, project: ClientDashboardModule.ClientProject) => {
    if (project.archived) {
      return;
    }
    const current = stateRef.current;
    if (current.checkedProjects.includes(id)) {
      return;
    }
    updateState({
      checkedProjects: [...current.checkedProjects, id],
    });
  };

  const handleProjectItemClicked = (
    id?: number | undefined,
    itemId?: number,
    target?: 'summary',
    clientDisplayName?: string,
    customOrderType?: string | null
  ) => {
    if (!stateRef.current.accountCanSeePricing) {
      return;
    }
    if (typeof id === 'number' && typeof itemId === 'number') {
      gotoDraperyOrder(id, itemId, clientDisplayName, target || 'summary', customOrderType);
    }
  };

  const handleClientClicked = (clientId?: number) => {
    if (typeof clientId !== 'number') return;
    props.history.push(`/clients/${clientId}`);
  };

  const handlePrintModal = (value: boolean) => {
    updateState({ isPrintModalOpen: value });
  };

  const handlePrint = async () => {
    const current = stateRef.current;
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    const storeId = `${propsRef?.current?.accountId}_pdfs`;
    updateState({ generatePdf: true });
    const arrProjects = [...current.projectList];
    const checkedProjects = current.checkedProjects;

    const projects = arrProjects.filter((p: ClientDashboardModule.ClientProject) => {
      const projectId = Number(p.itemId ?? p.id);
      return (
        Number.isFinite(projectId) &&
        checkedProjects.includes(projectId) &&
        !p.workOrderPdfLink &&
        p.workOrderId
      );
    });

    if (projects.length > 0) {
      for (const project of projects) {
        if (project.id) {
          const res = await getWorkOrderPDFContent(project.id);
          const resDraperyOrder = await getAllInfo(project.id);
          const workOrder: WorkOrderModule.WorkOrder = resDraperyOrder.workOrder;

          let pdfLink;
          let dueDate = res.dueDate;
          let dueDateForLambda = dueDate ? moment(dueDate).local().format('MM/DD/YYYY') : '';
          let buffer;
          const needNewPDF = !moment
            .utc(workOrder.dueDatePdf || undefined)
            .startOf('day')
            .isSame(moment.utc(res.dueDate || undefined).startOf('day'));
          const responseForLambda = { ...res, dueDate: dueDateForLambda, needNewPDF: needNewPDF };

          if (!workOrder.pdfLink || needNewPDF) {
            const lambdaResponse = await callLambda(
              responseForLambda,
              propsRef?.current?.accountId,
              '',
              workOrder
            );

            const { pdfData } = lambdaResponse;
            buffer = pdfData ? Buffer.from(pdfData, 'base64') : undefined;
            pdfLink = getPdfFileNameFromLambdaResponse(lambdaResponse);
            const index = arrProjects.findIndex((item) => item.id === project.id);
            arrProjects[index].workOrderPdfLink = pdfLink;
            project.workOrderPdfLink = pdfLink;

            await editWorkOrder({ ...workOrder, dueDatePdf: dueDateForLambda });
          }
          if (buffer && pdfLink) {
            await storeFile(storeId, pdfLink, buffer, Config.fileStoreUrl);
          }

          if (!workOrder.pdfLink) {
            await editWorkOrder({ ...workOrder, pdfLink, pdfGeneratedAt: new Date() });
          }
        }
      }
    }

    updateState({ projectList: arrProjects });

    try {
      const workOrderPdfLinks = arrProjects
        .filter((p) => {
          const projectId = Number(p.itemId ?? p.id);
          return (
            Number.isFinite(projectId) &&
            checkedProjects.includes(projectId) &&
            p.hasOwnProperty('workOrderId')
          );
        })
        .map((item) => item.workOrderPdfLink);
      const res = await mergePdfFiles(workOrderPdfLinks, storeId);
      const url = await getMergedPdfPrintUrl(res);

      iframe.src = url;
      document.body.appendChild(iframe);
      const handle = () => {
        try {
          if (iframe.contentWindow) {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          }
        } finally {
          updateState({ isPrintModalOpen: false, generatePdf: false });
        }
      };
      handle();
    } catch (error) {
      showErrorToast(
        isMergePdfNoneFoundError(error)
          ? 'None of the selected PDFs were found. Open the order and regenerate PDF, then try again.'
          : 'Unable to print selected work orders. Please try again.'
      );
      updateState({ isPrintModalOpen: false, generatePdf: false });
    }
  };

  const handleProjectWorkOrderNumClicked = async (id: number) => {
    const { workOrderPdfStatus: draperyPdf } = stateRef.current;
    const accountId = propsRef?.current?.accountId;
    if (draperyPdf === 'none') {
      const res = await getWorkOrderPDFContent(id);

      if (res.error) {
        return;
      }
      updateState({
        isLoadingOpen: true,
        workOrderPdfStatus: 'downloading',
        workOrderPdfContent: res,
      });

      const resDraperyOrder = await getAllInfo(id);
      const workOrder: WorkOrderModule.WorkOrder = resDraperyOrder.workOrder;
      const draperyOrderDesign = resDraperyOrder?.draperyOrderDesign;
      const storeId = `${accountId}_pdfs`;
      let pdfLink;
      let buffer;
      let dueDate = res.dueDate;
      let dueDateForLambda = dueDate ? moment(dueDate).local().format('MM/DD/YYYY') : '';

      const needNewPDF = !moment
        .utc(workOrder.dueDatePdf || undefined)
        .startOf('day')
        .isSame(moment.utc(res.dueDate || undefined).startOf('day'));
      const responseForLambda = { ...res, dueDate: dueDateForLambda, needNewPDF: needNewPDF };

      const openBuffer = (pdfBuffer: Uint8Array) => {
        const normalizedBuffer = new Uint8Array(pdfBuffer).slice().buffer;
        const blob = new Blob([normalizedBuffer], {
          type: 'application/pdf',
        });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
      };

      const regeneratePdf = async () => {
        let nextDrawingUrl: string | null = null;
        if (draperyOrderDesign?.id) {
          try {
            nextDrawingUrl = await regenerateWorkOrderDrawing({
              accountId,
              design: draperyOrderDesign,
              orderType: resDraperyOrder?.orderType,
            });
          } catch (error) {
            console.error('Failed to regenerate work order drawing before PDF generation', error);
          }
        }

        const lambdaResponse = await callLambda(
          {
            ...responseForLambda,
            ...(nextDrawingUrl ? { draperyImage: nextDrawingUrl } : {}),
            needNewPDF: true,
          },
          accountId,
          '',
          workOrder
        );

        const { pdfData } = lambdaResponse;
        pdfLink = getPdfFileNameFromLambdaResponse(lambdaResponse);
        buffer = pdfData ? Buffer.from(pdfData, 'base64') : undefined;
        await editWorkOrder({
          ...workOrder,
          pdfLink,
          dueDatePdf: dueDateForLambda,
          pdfGeneratedAt: new Date(),
        });
      };

      if (!workOrder.pdfLink || needNewPDF) {
        await regeneratePdf();
      }

      if (buffer && pdfLink) {
        await storeFile(storeId, pdfLink, buffer, Config.fileStoreUrl);
      }

      if (buffer) {
        openBuffer(buffer);
      } else {
        const fileName = pdfLink ? pdfLink : workOrder.pdfLink;
        if (fileName) {
          try {
            await openStoredPdf(storeId, fileName, Config.fileStoreUrl);
          } catch (error) {
            if (!isStoredFileMissingError(error)) {
              throw error;
            }

            await regeneratePdf();

            if (buffer && pdfLink) {
              await storeFile(storeId, pdfLink, buffer, Config.fileStoreUrl);
              openBuffer(buffer);
            } else if (pdfLink) {
              await openStoredPdf(storeId, pdfLink, Config.fileStoreUrl);
            }
          }
        }
      }
      handleDraperyPdfFinished(true);
    }
  };

  const handleDraperyPdfFinished = (success: boolean) => {
    const { dispatch } = props;
    if (success) {
      if (!stateRef.current.isLoadingOpen) {
        const notification: NotificationsModule.Notification = {
          id: 0,
          message: 'Work order created successfully!',
          type: 'info',
        };
        dispatch(NotificationsModule.addNotification(notification));
      }
      updateState({
        workOrderPdfStatus: 'none',
        isLoadingOpen: false,
      });
    } else {
      if (!stateRef.current.isLoadingOpen) {
        const notification: NotificationsModule.Notification = {
          id: 0,
          message: 'Failed to create work order !',
          type: 'error',
        };
        dispatch(NotificationsModule.addNotification(notification));
      }
      updateState({
        workOrderPdfStatus: 'error',
        isLoadingOpen: false,
      });
    }
  };

  const updateProjects: ProjectOverviewTableProps['onEdited'] = (projects) => {
    const current = stateRef.current;
    const newProjects = [...current.projectList];
    for (const proj of projects) {
      const projIdx = current.projectList.findIndex((p) => p.itemId === proj.itemId);
      if (projIdx === -1) {
        continue;
      }
      newProjects[projIdx] = proj;
      editProjectItem(proj);
    }
    updateState({ projectList: newProjects });
  };

  const updateNotebook = (projId: number, filterOut: string) => {
    if (!projId) return;
    let foundProj: any = state?.projectList?.find((i) => i.id === projId);
    if (!foundProj) return;
    let notebook = foundProj?.notebook || [];
    let filteredNotebook = notebook?.filter((i: any) => i.type !== filterOut);
    foundProj.notebook = filteredNotebook || [];

    setState((prev) => {
      return {
        ...prev,
        projectList: prev.projectList?.map((item: any) => {
          if (item?.id === foundProj?.id) {
            return foundProj;
          }
          return item;
        }),
      };
    });
  };

  const editProjectItem = async (project: ClientDashboardModule.ClientProject): Promise<void> => {
    const res: any = await editClientProject(project);

    trackView(MixpanelEvents.UPDATE_ORDER, {
      orderId: project.itemId,
      orderType: project.orderType,
      element: 'three_dot_menu',
    });

    if (res.error) {
      trackView(MixpanelEvents.UPDATE_ORDER, {
        orderId: project.itemId,
        orderType: project.orderType,
        be_error_text: res && res.message ? res.message : res,
        element: 'three_dot_menu',
      });
      return;
    }
  };

  const handleProjectAction = async (
    value: string,
    type?: string,
    selectedProjectIds?: number[]
  ): Promise<void> => {
    const current = stateRef.current;
    if (!current.accountCanSeePricing && ['Duplicate'].includes(value)) {
      return;
    }
    const { checkedProjects, projectList } = current;
    const selectedIds =
      selectedProjectIds && selectedProjectIds.length
        ? Array.from(new Set([...checkedProjects, ...selectedProjectIds]))
        : checkedProjects;
    switch (value) {
      case 'Archive': {
        void processItems('archive', undefined, undefined, selectedIds);
        return;
      }
      case 'Unarchive': {
        void processItems('unarchive', undefined, undefined, selectedIds);
        return;
      }
      case 'Batch Edit': {
        updateState({ isEditItemsModalOpen: true });
        return;
      }
      case 'Duplicate': {
        updateState({ duplicateLoading: true, isModalOpen: false });
        try {
          const projectsToProcess = projectList.filter((project) =>
            selectedIds.includes(project.itemId)
          );

          // array for purchased goods duplicate
          let duplicatePurchasedGoodIds: any[] =
            projectsToProcess?.filter((i) => i.orderType === 'purchased-goods') || [];

          // rest of items for duplicate
          let restDuplicateItems = projectsToProcess?.filter(
            (i) => i.orderType !== 'purchased-goods'
          );

          if (duplicatePurchasedGoodIds?.length > 0) {
            if (duplicatePurchasedGoodIds?.length === 1) {
              props.handleShowBottomSheet(true, null);
              let payloadItem = duplicatePurchasedGoodIds?.[0]
              if (props.handlePreFill) {
                props.handlePreFill({
                  duplicate: true,
                  item: payloadItem
                });
              }
            } else {
              const payload = {
                ids: duplicatePurchasedGoodIds?.map((i) => i.id),
              };
              await duplicatePurchasedGood(payload);
            }
          }

          if (restDuplicateItems?.length > 0) {
            const can_create_order = await userCanCreateNewOrder(propsRef?.current?.accountId);
            const total_orders_length = await getTotalNumberCount(propsRef?.current?.accountId);
            let order_type: string;
            let duplicate_check_case: boolean = false;
            const order_limit = await retrieveMetadata(propsRef?.current?.accountId);

            if (
              order_limit &&
              order_limit.error &&
              order_limit.error.response &&
              order_limit.error.response.data &&
              order_limit.error.response.data.error &&
              order_limit.error.response.data.error.includes('Not Found')
            ) {
              order_type = 'error';
            } else {
              order_type = order_limit && order_limit.item_order ? 'has_limit' : 'unlimited';
            }
            if (order_type) {
              switch (order_type) {
                case 'has_limit': {
                  const planLimit = Number(order_limit.item_order || 0);
                  const totalSoFar = Number(total_orders_length);
                  const toCreate = restDuplicateItems.length;

                  const leftInPlan = Math.max(0, planLimit - totalSoFar);
                  const deficit = Math.max(0, toCreate - leftInPlan);
                  duplicate_check_case = deficit === 0 || current.remainingItemOrder >= deficit;
                  break;
                }
                case 'unlimited':
                  duplicate_check_case = true;
                  break;
                case 'error':
                  duplicate_check_case = false;
                  break;
                default:
                  console.log('default switch state');
              }
            }
            if ((!can_create_order && current.remainingItemOrder === 0) || !duplicate_check_case) {
              propsRef.current.handleOpenSubscriptionPlanModal();
              return;
            }

            let restDuplicateItemsIds: number[] = [];
            restDuplicateItems?.forEach((i) => {
              if (i.id) restDuplicateItemsIds.push(i.id);
            });

            await processItems('duplicate', undefined, type, restDuplicateItemsIds);
          } else if (duplicatePurchasedGoodIds?.length > 0) {
            setState((prev) => {
              return {
                ...prev,
                checkedProjects: [],
                isModalOpen: false,
              };
            });
            await loadProjects();
          }

          return;
        } finally {
          updateState({ duplicateLoading: false });
        }
      }
      case 'Delete': {
        void processItems('delete', undefined, undefined, selectedIds);
        return;
      }
    }
  };

  const processItems = async (
    action: 'archive' | 'unarchive' | 'duplicate' | 'edit' | 'delete',
    isActive?: boolean,
    type?: string,
    projectIds?: number[]
  ) => {
    if (
      !stateRef.current.accountCanSeePricing &&
      !['archive', 'unarchive', 'delete', 'edit'].includes(action)
    ) {
      return;
    }
    const { accountId } = propsRef.current;
    const current = stateRef.current;
    const { projectList, checkedProjects } = current;
    const effectiveIds =
      projectIds && projectIds.length
        ? // ? Array.from(new Set([...checkedProjects, ...projectIds]))
          Array.from(new Set(projectIds))
        : checkedProjects;
    const projectsToProcess = projectList.filter((project) =>
      effectiveIds.includes(project.itemId)
    );
    if (action === 'edit' && isActive === false) {
      for (const project of projectList) {
        const res = await archiveClientProjectItem({
          accountId,
          draperyOrderId: project.itemId,
          archived: action === 'edit',
        });
        if (res.error) {
          return;
        }
      }
      void loadProjects();
    } else if (projectList.length === 0) {
      const sort = current.sortValue;
      const filters = {
        client: current.filters.client.value,
        status: current.filters.status.value,
        estimate: current.filters.estimate.value,
        invoice: current.filters.invoice.value,
        items: current.filters.items.value,
        assignee: canUseRoleAssignments ? current.filters.assignee.value : [],
      };

      const getProjectsRes = await getAllProjects(
        parseFloat(localStorage.getItem('accountId') || '0'),
        true,
        sort,
        current.pageLimit,
        current.pageNumber,
        current.searchTerm,
        filters
      );
      if (Array.isArray(getProjectsRes)) {
        for (const project of getProjectsRes) {
          const res = await archiveClientProjectItem({
            accountId,
            draperyOrderId: project.itemId,
            archived: false,
          });
          void loadProjects();

          if (res.error) {
            return;
          }
        }
      }
    }

    if (!projectsToProcess.length) {
      return;
    }
    let remainingItemOrder = current.remainingItemOrder;
    for (const project of projectsToProcess) {
      if (
        (action === 'archive' && !project.archived) ||
        (action === 'unarchive' && project.archived)
      ) {
        const res = await archiveClientProjectItem({
          accountId,
          draperyOrderId: project.itemId,
          archived: action === 'archive',
        });
        if (res.error) {
          return;
        }
      } else if (action === 'duplicate') {
        const canCreateOrder = await userCanCreateNewOrder(propsRef?.current?.accountId);
        const res: any = await draperyOrderCopy({
          accountId,
          draperyOrderId: project.itemId,
          isFromExtraOrderCredit: !canCreateOrder && remainingItemOrder > 0 ? true : false,
        });

        if (!canCreateOrder) {
          await updateAccount({ accountId, remainingItemOrder: remainingItemOrder - 1 });
          remainingItemOrder--;
        }
        let orderType;

        if (project && project.orderType) {
          const type = project.orderType;

          if (type === 'custom-order') {
            orderType = 'other';
          } else if (type === 'roman-shade') {
            orderType = 'roman_shade';
          } else if (type === 'drapery-order') {
            orderType = 'drapery';
          } else {
            orderType = type;
          }
        } else {
          orderType = 'unknown';
        }

        let clientName = '';
        if (project && project.client && project.client.displayName) {
          clientName = project.client.displayName;
        }

        trackView(MixpanelEvents.DUPLICATE_ORDER, {
          orderId: project.itemId,
          orderType,
          element: 'three_dot_menu',
          client_name: clientName,
        });

        if (res.error) {
          trackView(MixpanelEvents.DUPLICATE_ORDER, {
            orderId: project.itemId,
            orderType,
            be_error_text: res && res.message ? res.message : res,
            element: 'three_dot_menu',
            client_name: clientName,
          });
          return;
        }
        if (projectsToProcess.length === 1)
          localStorage.setItem(
            'duplicate',
            JSON.stringify({ id: res.newOrderId, orderType: project.orderType })
          );
        if (project.client && type === 'singleItem') {
          gotoDraperyOrder(
            project.client.id,
            res.newOrderId,
            project.client.displayName,
            'setup',
            project.orderType
          );
        }
        updateState({ remainingItemOrder });
      }
    }
    if (action === 'delete') {
      for (const project of projectsToProcess) {
        const res = await deleteClientProject(project);

        let orderType;

        if (project && project.orderType) {
          const type = project.orderType;

          if (type === 'custom-order') {
            orderType = 'other';
          } else if (type === 'roman-shade') {
            orderType = 'roman_shade';
          } else if (type === 'drapery-order') {
            orderType = 'drapery';
          } else {
            orderType = type;
          }
        } else {
          orderType = 'unknown';
        }

        trackView(MixpanelEvents.DELETE_ORDER, {
          orderId: project.itemId,
          orderType,
          element: 'three_dot_menu',
        });

        if (res.error) {
          trackView(MixpanelEvents.DELETE_ORDER, {
            orderId: project.itemId,
            orderType,
            be_error_text: res && res.message ? res.message : res,
            element: 'three_dot_menu',
          });
          return;
        }
      }
    }
    updateState({
      checkedProjects: [],
      isModalOpen: false,
    });
    await loadProjects();
  };

  const onShowArchiveChange = (isShow: boolean): void => {
    updateState({
      showArchived: isShow,
    });
    void loadProjects({ showArchived: isShow });
  };

  const onOpenModal = (value: string) => {
    if (
      !stateRef.current.accountCanSeePricing &&
      ['Duplicate', 'DuplicateBlocked'].includes(value)
    ) {
      return;
    }
    updateState({ isModalOpen: true, value });
  };

  const mapSortTableToSortOptions = useCallback(
    (sortTable: SortTable): void => {
      const nextSortValue = {
        field: sortTable.field,
        direction: sortTable.position === 1 ? 'ASC' : 'DESC',
      } as const;

      const currentSortValue = stateRef.current.sortValue;
      if (
        currentSortValue.field === nextSortValue.field &&
        currentSortValue.direction === nextSortValue.direction
      ) {
        return;
      }

      updateState({
        sortValue: nextSortValue,
      });
    },
    [updateState]
  );

  // const onAreaScroll = (e: UIEvent<HTMLDivElement>): void => {
  //   updateState({
  //     areaScrollInfo: {
  //       scrollX: e.currentTarget.scrollLeft,
  //       scrollY: e.currentTarget.scrollTop,
  //     },
  //   });
  // };

  const gotoDraperyOrder = (
    clientId: number | undefined,
    draperyOrderId?: number,
    clientDisplayName?: string,
    tab?: 'summary' | 'setup',
    customOrderType?: string | null
  ) => {
    const { history } = propsRef.current;
    let draperyItem: any = localStorage.getItem('draperyItem');
    if (draperyItem) {
      draperyItem = JSON.parse(draperyItem);
    } else {
      draperyItem = {};
    }
    draperyItem.from = location.pathname;

    let romanShadeItem: any = localStorage.getItem('romanShadeItem');
    if (romanShadeItem) {
      romanShadeItem = JSON.parse(romanShadeItem);
    } else {
      romanShadeItem = {};
    }
    romanShadeItem.from = location.pathname;

    localStorage.setItem('draperyItem', JSON.stringify(draperyItem));
    localStorage.setItem('romanShadeItem', JSON.stringify(romanShadeItem));

    history.push(
      `/calculator${customOrderType ? `?type=${customOrderType}` : '?type=drapery-order'}`,
      {
        clientId,
        draperyOrderId,
        clientDisplayName,
        tab,
        type: customOrderType ? customOrderType : 'drapery-order',
        referrer: location.pathname,
      }
    );
  };

  const editItemModalClose = () => {
    updateState({ isEditItemsModalOpen: false });
  };

  const batchEdit: EditItemsModalProps['onSave'] = async (newValues) => {
    const current = stateRef.current;
    if (!current.checkedProjects.length) {
      return;
    }
    updateState({ isEditClientModalOpen: false });
    const estimateBatchEditFields = new Set([
      'estimateStatus',
      'estimateNumber',
      'qbEstimateNumber',
      'estimateDate',
      'estimateDateSent',
      'changedFields',
    ]);
    const changedFields = newValues.changedFields || {};
    const nonEmptyValues = Object.entries(newValues).reduce((all, [key, val]) => {
      if (val && !estimateBatchEditFields.has(key)) {
        all[key] = val;
      }
      return all;
    }, {} as Partial<EditValues>);
    if (newValues.estimateStatus) {
      nonEmptyValues.estimateStatus = newValues.estimateStatus;
    }
    if (newValues.estimateNumber || changedFields.estimateNumber) {
      nonEmptyValues.estimateNumber = newValues.estimateNumber || null;
    }
    if (newValues.qbEstimateNumber || changedFields.qbEstimateNumber) {
      nonEmptyValues.qbEstimateNumber = newValues.qbEstimateNumber || null;
    }
    if (
      changedFields.estimateDateSent ||
      (newValues.estimateDateSent !== null && newValues.estimateDateSent !== undefined)
    ) {
      nonEmptyValues.estimateDateSent = newValues.estimateDateSent || null;
      nonEmptyValues.estimateDate = newValues.estimateDateSent || null;
    }

    const filteredNewProjects = current.projectList.filter((i) => !i.archived);

    let newProjects = [...filteredNewProjects];
    for (const id of current.checkedProjects) {
      const projIdx = newProjects.findIndex((proj) => proj.itemId === id);
      if (projIdx === -1) {
        continue;
      }
      const proj = newProjects[projIdx];
      if (!proj) {
        continue;
      }
      const newProj: ClientDashboardModule.ClientProject = {
        ...proj,
        ...nonEmptyValues,
      };

      newProjects[projIdx] = newProj;

      await editProjectItem(newProj);
      void loadProjects();
    }
    updateState({
      projectList: newProjects,
      checkedProjects: [],
      isEditItemsModalOpen: false,
    });
  };

  const handleSearchClient: SearchSelectProps['onSearch'] = async (search: string) => {
    const res = await searchClients({
      text: search,
      accountId: parseFloat(localStorage.getItem('accountId') || '0'),
    });

    if (res.error) {
      return [];
    }
    return res.map((r: any) => ({
      id: r.id,
      displayName: (r.parent ? r.parent.displayName + ' | ' : '') + r.displayName,
    }));
  };

  const toggleLoadingModal = () => {
    updateState((prev) => ({ isLoadingOpen: !prev.isLoadingOpen }));
  };

  const handleNewClientProject = async (type: string) => {
    const current = stateRef.current;
    updateState({ isSubmenuOpened: false });
    const can_create_order = await userCanCreateNewOrder(propsRef?.current?.accountId);
    if (!can_create_order && current.remainingItemOrder === 0 && type !== 'custom-order') {
      propsRef.current.handleOpenSubscriptionPlanModal();
      return;
    }
    if (current.client) {
      gotoDraperyOrder(current.client.id, 0, current.client.displayName, 'summary', type);
    } else {
      propsRef.current.history.push(`/calculator?type=${type}` as string, {
        type: type,
        referrer: location.pathname,
      });
    }
  };

  const handleTriggerRefetch = () => {
    updateState((prev) => ({ refetch: !prev.refetch }));
  };

  const handleTriggerProjectRefetch = () => {
    updateState((prev) => ({ projectRefetch: !prev.projectRefetch }));
  };

  const handleChangeValueSearchInput = (e: ChangeEvent<HTMLInputElement>): void => {
    updateState({ searchTerm: e.currentTarget.value });
  };

  const handleSearchInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    const searchTerm = e.currentTarget.value;
    if (stateRef.current.pageNumber !== 1) {
      updateState({ pageNumber: 1, searchTerm });
      return;
    }
    void loadProjects({ pageNumber: 1, searchTerm });
  };

  const handleClearSearchKeyword = (): void => {
    updateState({ searchTerm: '' });
  };

  const handleCloseRomanShadePopUp = (): void => {
    updateState({ romanShadePopUp: 0 });
  };

  const handleCloseRipplefoldPopUp = (): void => {
    updateState({ ripplefoldPopUp: 0 });
  };

  const handleCloseHardwarePopUp = (): void => {
    updateState({ hardwarePopUp: 0 });
  };

  const handleCloseOtherItemPopUp = (): void => {
    updateState({ otherItemPopUp: 0 });
  };

  const handleCloseRomanShadeCalculationsPopUp = (): void => {
    updateState({ romanShadeCalculationsPopUp: 0 });
  };

  const handleOpenMyShop = (): void => {
    propsRef.current.history.push('/myShop?ripplefold_pop_up=true');
  };

  const handleOpenHardwareTab = (): void => {
    propsRef.current.history.push('/calculator?type=drapery-order', { type: 'drapery-order' });
  };

  const handleOpenRomanShadeOrder = (): void => {
    propsRef.current.history.push('/calculator?type=roman-shade-order', {
      type: 'roman-shade-order',
    });
  };

  const handleOpenOtherItemOrder = (): void => {
    propsRef.current.history.push('/calculator?type=custom-order', { type: 'custom-order' });
  };

  const handleOpenRomanShadeCalculationsPopUp = async (): Promise<void> => {
    await handleSeedOtherItems();
    await handleSeedRomanShadeConstructions();

    propsRef.current.history.push('/myshop?item=roman-shade-item');
  };

  const handleSeedOtherItems = async (): Promise<void> => {
    const alreadySeeded = localStorage.getItem('seed-otheritems') || 'null';
    const parsedAlreadySeeded = JSON.parse(alreadySeeded);
    if (!parsedAlreadySeeded) {
      await seedItemsOnLogin();
      localStorage.setItem('seed-otheritems', JSON.stringify(true));
    }
  };

  const handleSeedRomanShadeConstructions = async (): Promise<void> => {
    const accountId = localStorage.getItem('accountId');
    if (accountId) {
      const defaultItemList = [{ type: 4, name: 'Roman Shade' }];
      for (const defaultItem of defaultItemList) {
        const draperyFullnessValue = defaultItem.type === 3 ? 1 : 2.5;
        try {
          const result = await addWorkroomSetting({
            accountId,
            type: defaultItem.type,
            name: defaultItem.name,
            presetIsYardageAddOneExtra: true,
            presetIsYardageAddExcess: false,
            buckram: 'Ask for each order',
            presetAddExcessUnit: '%',
            presetDraperyFullnessJson: {
              value: draperyFullnessValue,
            },
          });

          if (result.error) {
            throw new Error(result.payload.message);
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  };

  const handleCloseModal = async () => {
    const { accountId } = propsRef.current;

    const res = await updateAccount({
      accountId: accountId,
      isModalOpen: stateRef.current.isPopUpChecked,
    });

    if (res.error) {
      throw new Error(res.message);
    }
    localStorage.setItem('showModal', 'false');
    const showModal = localStorage.getItem('showModal');
    updateState({ showModal: showModal });
  };

  const handleCheckModal = (checked: boolean) => {
    updateState({ isPopUpChecked: checked });
  };

  const handleResetNewStatus = () => {
    updateState({ newStatusFilterValue: '', newStatusFilter: false });
  };

  const handleChooseFilter = (filter: string, filter_field: any) => {
    switch (filter_field) {
      case 'client':
        updateState((prev) => ({
          filter_dropdown: '',
          pageNumber: 1,
          filters: {
            ...prev.filters,
            [filter_field]: {
              ...prev.filters[filter_field],
              value: filter ? [filter] : [],
            },
          },
          filtersDraft: {
            ...prev.filtersDraft,
            [filter_field]: {
              ...prev.filtersDraft[filter_field],
              value: filter ? [filter] : [],
            },
          },
        }));
        break;
      case 'status':
      case 'estimate':
      case 'invoice':
      case 'assignee': {
        let set_array = stateRef.current.filters[filter_field].value || [];

        if (
          stateRef.current.filters[filter_field] &&
          stateRef.current.filters[filter_field].value &&
          stateRef.current.filters[filter_field].value.includes(filter)
        ) {
          set_array = set_array.filter((s: any) => s !== filter);
        } else {
          set_array = [...set_array, filter];
        }

        updateState((prev) => ({
          pageNumber: 1,
          filters: {
            ...prev.filters,
            [filter_field]: {
              ...prev.filters[filter_field],
              value: set_array,
            },
          },
          filtersDraft: {
            ...prev.filtersDraft,
            [filter_field]: {
              ...prev.filtersDraft[filter_field],
              value: set_array,
            },
          },
        }));
        break;
      }
      case 'items': {
        if (isAllItemsOption(filter)) {
          updateState((prev) => ({
            pageNumber: 1,
            filters: {
              ...prev.filters,
              items: { value: [] },
            },
            filtersDraft: {
              ...prev.filtersDraft,
              items: { value: [] },
            },
          }));
          break;
        }

        let set_array = (stateRef.current.filters.items.value || []).filter(
          (item: string) => !isAllItemsOption(item)
        );

        if (set_array.includes(filter)) {
          set_array = set_array.filter((s: any) => s !== filter);
        } else {
          set_array = [...set_array, filter];
        }

        updateState((prev) => ({
          pageNumber: 1,
          filters: {
            ...prev.filters,
            items: {
              ...prev.filters.items,
              value: set_array,
            },
          },
          filtersDraft: {
            ...prev.filtersDraft,
            items: {
              ...prev.filtersDraft.items,
              value: set_array,
            },
          },
        }));
        break;
      }
      default:
        return;
    }
  };

  const handleClearAllFilter = (filter_field: any) => {
    switch (filter_field) {
      case 'status':
      case 'estimate':
      case 'invoice':
      case 'assignee':
      case 'items':
        updateState((prev) => ({
          pageNumber: 1,
          filters: {
            ...prev.filters,
            [filter_field]: {
              ...prev.filters[filter_field],
              value: [],
            },
          },
          filtersDraft: {
            ...prev.filtersDraft,
            [filter_field]: {
              ...prev.filtersDraft[filter_field],
              value: [],
            },
          },
        }));
        break;
      default:
        return;
    }
  };

  const handleClearAllFilterDraft = (filter_field: any) => {
    switch (filter_field) {
      case 'status':
      case 'estimate':
      case 'invoice':
      case 'assignee':
      case 'items':
        updateState((prev) => ({
          filtersDraft: {
            ...prev.filtersDraft,
            [filter_field]: {
              ...prev.filtersDraft[filter_field],
              value: [],
            },
          },
        }));
        break;
      default:
        return;
    }
  };

  const handleChooseFilterDraft = (filter: string, filter_field: any) => {
    switch (filter_field) {
      case 'client':
        updateState((prev) => ({
          filter_dropdown: '',
          filtersDraft: {
            ...prev.filtersDraft,
            [filter_field]: {
              ...prev.filtersDraft[filter_field],
              value: filter ? [filter] : [],
            },
          },
        }));
        break;
      case 'status':
      case 'estimate':
      case 'invoice':
      case 'assignee': {
        let set_array = stateRef.current.filtersDraft[filter_field].value || [];

        if (
          stateRef.current.filtersDraft[filter_field] &&
          stateRef.current.filtersDraft[filter_field].value &&
          stateRef.current.filtersDraft[filter_field].value.includes(filter)
        ) {
          set_array = set_array.filter((s: any) => s !== filter);
        } else {
          set_array = [...set_array, filter];
        }

        updateState((prev) => ({
          filtersDraft: {
            ...prev.filtersDraft,
            [filter_field]: {
              ...prev.filtersDraft[filter_field],
              value: set_array,
            },
          },
        }));
        break;
      }
      case 'items': {
        if (isAllItemsOption(filter)) {
          updateState((prev) => ({
            filtersDraft: {
              ...prev.filtersDraft,
              items: { value: [] },
            },
          }));
          break;
        }

        let set_array = (stateRef.current.filtersDraft.items.value || []).filter(
          (item: string) => !isAllItemsOption(item)
        );

        if (set_array.includes(filter)) {
          set_array = set_array.filter((s: any) => s !== filter);
        } else {
          set_array = [...set_array, filter];
        }

        updateState((prev) => ({
          filtersDraft: {
            ...prev.filtersDraft,
            items: {
              ...prev.filtersDraft.items,
              value: set_array,
            },
          },
        }));
        break;
      }
      default:
        return;
    }
  };

  const handleShowArchived = (filter_name: string) => {
    updateState((prev) => ({
      filters: {
        ...prev.filters,
        [filter_name]: {
          ...prev.filters[filter_name],
          archived: !prev.filters[filter_name].archived,
        },
      },
      filtersDraft: {
        ...prev.filtersDraft,
        [filter_name]: {
          ...prev.filtersDraft[filter_name],
          archived: !prev.filtersDraft[filter_name].archived,
        },
      },
    }));
  };

  const handleEstimate = async (ids: number[]) => {
    if (!stateRef.current.accountCanSeePricing) {
      return;
    }
    updateState({ exportingEstimateLoading: true });
    const res = await quickbooksCheckIsConnected(propsRef?.current?.accountId);
    const { dispatch } = propsRef.current;

    if (res.connected === true && res.userinfo) {
      const res = await exportEstimate(ids, propsRef?.current?.accountId, []);

      if (!ids.length) return;
      if (!res.error) {
        if (ids.length === 1) {
          const project = [...stateRef.current.projectList].find((p) => p.itemId === ids[0]);
          if (project) {
            const newValues = {
              ...project,
              estimateDateSent: new Date(),
              estimateStatus: 'Exported to QB',
            };
            await editProjectItem(newValues);
          }
        } else {
          const projects = [...stateRef.current.projectList].filter((p) => ids.includes(p.itemId));
          const promises = projects.map(async (p) => {
            const newValues = {
              ...p,
              estimateDateSent: new Date(),
              estimateStatus: 'Exported to QB',
            };
            return await editProjectItem(newValues);
          });
          await Promise.all([...promises]);
        }
        void loadProjects();
        updateState({
          isEstimateModalOpen: true,
          checkedProjects: [],
          qbEstimateId: res.estimateId,
          exportingEstimateLoading: false,
        });
      }
      if (res.error) {
        updateState({ exportingEstimateLoading: false });
        const notification: NotificationsModule.AddNotificationPayload = {
          message: getQuickBooksOnlineErrorTitle(res) || 'Error!',
          subMessage: `${res.message}`,
          type: 'error',
          source: getQuickBooksOnlineNotificationSource(res),
        };
        dispatch(NotificationsModule.addNotification(notification));
      }
    } else {
      propsRef.current.history.push('/quickbooks_connect');
    }
  };

  const handleCloseInvitePanel = () => {
    setIsInvitePanelOpen(false);
    setOpenPermissionTooltip(null);
  };

  const ensureCanManageTeamMembers = (): boolean => {
    if (canManageTeamMembers) {
      return true;
    }
    showErrorToast('You do not have permission to edit team members.');
    return false;
  };

  const getUsedAssigneeLabels = (excludeAssigneeId?: number): Set<string> =>
    collectUsedLabels(teamMembers, pendingInvitations, assigneesWithoutLogin, excludeAssigneeId);

  const fetchAssignees = async (scopeAccountId: number = assigneeScopeAccountId) => {
    if (!scopeAccountId) {
      setAssigneesWithoutLogin([]);
      return;
    }

    try {
      const assignees = await loadAssigneesForAccount(scopeAccountId);
      setAssigneesWithoutLogin((assignees || []).map(mapAssigneePayloadToRow));
    } catch (error) {
      showErrorToast('Failed to fetch assignees. Please try again later.');
    }
  };

  const loadSeatUsage = async () => {
    const accountId = Number(managedAccountId || 0);
    if (!accountId) {
      return;
    }

    if (seatUsageRequestRef.current?.accountId === accountId) {
      return seatUsageRequestRef.current.promise;
    }

    const request = (async () => {
      try {
        const planInfoRes = await getCustomerPlanInfo(accountId);
        let planInfo = planInfoRes['main'];
        let planInfoSeat = planInfoRes['seat'];

        if (!planInfoRes || planInfoRes.error || !planInfo) {
          return;
        }
        if (typeof planInfo.planName === 'string') {
          setPlanName(planInfo.planName);
        }
        let mainPlanInfo = extractSeatLimitFromPlanInfo(planInfo);
        let seatsSum = (planInfoSeat?.quantity || 0) + mainPlanInfo;
        setAvailableSlots(seatsSum);
      } catch (error) {
        // Seat usage is supplemental UI data; keep page functional if unavailable.
        console.error('Failed to load seat usage:', error);
      } finally {
        if (seatUsageRequestRef.current?.accountId === accountId) {
          seatUsageRequestRef.current = null;
        }
      }
    })();

    seatUsageRequestRef.current = { accountId, promise: request };
    return request;
  };

  const fetchTeamData = async (userOverride?: any) => {
    if (!propsRef?.current?.accountId) {
      return;
    }

    try {
      const user =
        userOverride ||
        (await getUser({
          accountId: propsRef?.current?.accountId,
          includeTeamData: true,
        }));
      const ownerAccountId = resolveOwnerAccountIdFromTeamContext(
        user?.teamContext,
        ownerAccountIdFromStorage || managedAccountId || propsRef?.current?.accountId
      );

      if (ownerAccountId && ownerAccountId !== managedAccountId) {
        setTeamScopeAccountId(ownerAccountId);
      }

      const allTeamMembers = Array.isArray(user?.teamContext?.teamMembers)
        ? user.teamContext.teamMembers
        : [];
      const members = allTeamMembers.filter(
        (member: any) => String(member?.type || '').toLowerCase() === 'subscribed'
      );

      const mappedMembers: TeamMemberRow[] = members.map((member: any) => ({
        id: !!member?.isOwner ? 'owner' : `account-${Number(member?.accountId || 0)}`,
        accountId: Number(member?.accountId || 0),
        firstName: String(member?.firstName || '').trim(),
        lastName: String(member?.lastName || '').trim(),
        email: String(member?.email || '').trim(),
        label: normalizeAssigneeLabelInput(String(member?.label || '').toUpperCase()),
        roles: normalizeRoleIds(member?.roles),
        isOwner: !!member?.isOwner,
        isAdmin: !!member?.isAdmin,
        pricingEnabled: !!member?.canSeePricing,
      }));

      let resolvedTeamMembers: TeamMemberRow[] = mappedMembers;
      if (mappedMembers.length === 0) {
        const fallbackIsOwner =
          !!user?.isOwner ||
          (ownerAccountId > 0 && ownerAccountId === propsRef?.current?.accountId);
        const fallbackIsAdmin = !!user?.isAdmin;
        resolvedTeamMembers = [
          {
            id: 'owner',
            accountId: ownerAccountId || propsRef?.current?.accountId,
            firstName,
            lastName,
            email: String(user?.email || '').trim(),
            label: normalizeAssigneeLabelInput(String(user?.label || '').toUpperCase()),
            roles: normalizeRoleIds(user?.roles),
            isOwner: fallbackIsOwner,
            isAdmin: fallbackIsAdmin,
            pricingEnabled: !!user?.canSeePricing,
          },
        ];
      }
      // setTeamMembers(resolvedTeamMembers);
      setTeamMemberPermissionBaseline(
        resolvedTeamMembers.reduce<Record<string, TeamMemberPermissionDraft>>((acc, member) => {
          acc[member.id] = {
            accountId: member.accountId,
            pricingEnabled: member.pricingEnabled,
            isAdmin: member.isAdmin,
          };
          return acc;
        }, {})
      );
      setPendingTeamMemberPermissions({});

      const ownerMember = mappedMembers.find((member) => member.isOwner);
      const ownerMemberSource = allTeamMembers.find(
        (member: any) => Number(member?.accountId) === ownerMember?.accountId
      );
      const ownerEmailFromContext =
        typeof user?.teamContext?.owner?.email === 'string' ? user.teamContext.owner.email : '';
      const currentUserEmail = typeof user?.email === 'string' ? user.email : '';
      setOwnerEmail(
        String(ownerMemberSource?.email || ownerEmailFromContext || currentUserEmail || '').trim()
      );

      const invitations = Array.isArray(user?.teamContext?.pendingInvitations)
        ? user.teamContext.pendingInvitations
        : [];
      const pendingInvitationsCount = invitations.length;
      setPendingSlots(pendingInvitationsCount);
      const ownerExistsInTeam = mappedMembers.some((member) => member.isOwner);
      const activeTeamMembersCount =
        mappedMembers.length > 0 ? mappedMembers.length + (ownerExistsInTeam ? 0 : 1) : 1;
      setUsedSlots(activeTeamMembersCount + pendingInvitationsCount);
      setPendingInvitations(
        invitations.map((invitation: any) => ({
          id: `pending-account-${Number(invitation?.accountId || 0)}`,
          accountId: Number(invitation?.accountId || 0),
          email: String(invitation?.email || '').trim(),
          label: normalizeAssigneeLabelInput(String(invitation?.label || '').toUpperCase()),
          roleIds: normalizeRoleIds(invitation?.roles),
          sentLabel: formatTimeAgo(invitation?.createdAt),
          statusLabel: 'Pending',
          isAdmin: !!invitation?.isAdmin,
          canSeePricing: !!invitation?.canSeePricing,
        }))
      );
    } catch (error) {
      console.error('Failed to load team settings data:', error);
    }
  };

  const handleSubmitInvitePanel = async () => {
    if (!ensureCanManageTeamMembers()) {
      return;
    }
    if (invitePanelMode === 'team_member') {
      if (isSeatLimitReached) {
        showErrorToast('Seat limit reached. Add seats before inviting more team members.');
        return;
      }
      if (isInvitingMember) {
        return;
      }
      const trimmedEmail = memberEmail.trim();
      if (!trimmedEmail || !trimmedEmail.includes('@')) {
        showErrorToast('Please enter a valid email.');
        return;
      }
      if (!propsRef?.current?.accountId) {
        showErrorToast('Account not found.');
        return;
      }

      try {
        setIsInvitingMember(true);
        await inviteMember({
          accountId: propsRef?.current?.accountId,
          email: trimmedEmail,
          roles: memberSelectedRoleIds,
          canSeePricing: memberPricingAccess,
          isAdmin: memberAdminAccess,
        });
        await Promise.all([fetchTeamData(), loadSeatUsage()]);
        showSuccessToast(`Invitation sent - An invitation has been sent to ${trimmedEmail}`);
        handleCloseInvitePanel();
      } catch (error: any) {
        if (error?.response?.status === 409) {
          showErrorToast('A user with this email address is already a team member.');
        } else if (error?.response?.status === 403) {
          showErrorToast('You do not have permission to invite team members.');
        } else {
          showErrorToast('Failed to send invitation. Please try again later.');
        }
      } finally {
        setIsInvitingMember(false);
      }
      return;
    }

    const trimmedName = assigneeName.trim();
    const trimmedLabel = normalizeAssigneeLabelInput(assigneeLabel);
    if (!trimmedName) {
      showErrorToast('Assignee name is required.');
      return;
    }
    if (!trimmedLabel || trimmedLabel.length < 1 || trimmedLabel.length > 4) {
      showErrorToast('Label must be 1 to 4 characters.');
      return;
    }
    if (getUsedAssigneeLabels().has(trimmedLabel)) {
      showErrorToast('Label is already in use for this account');
      return;
    }
    if (assigneeSelectedRoleIds.length === 0) {
      showErrorToast('Select at least one role for the assignee.');
      return;
    }

    if (!assigneeScopeAccountId) {
      showErrorToast('Account not found.');
      return;
    }

    try {
      setAssigneeMutationState('adding');
      await addNewAssignee({
        accountId: assigneeScopeAccountId,
        name: trimmedName,
        label: trimmedLabel,
        roles: assigneeSelectedRoleIds,
      });
      await fetchAssignees();
      showSuccessToast(`Assignee added - ${trimmedName} has been added as assignee`);
      handleCloseInvitePanel();
    } catch (error: any) {
      const apiMessage = extractApiErrorMessage(error);
      showErrorToast(apiMessage || 'Failed to add assignee. Please try again later.');
    } finally {
      setAssigneeMutationState(null);
    }
  };

  const resetInvitePanelForm = (mode: InvitePanelMode) => {
    if (mode === 'team_member') {
      setMemberEmail('');
      // setMemberSelectedRoleIds([]);
      setMemberPricingAccess(false);
      setMemberAdminAccess(false);
      return;
    }
    setAssigneeName('');
    setAssigneeLabel('');
    setIsAssigneeLabelAuto(true);
    // setAssigneeSelectedRoleIds([]);
  };

  const handleSwitchInviteMode = (mode: InvitePanelMode) => {
    if (!ensureCanManageTeamMembers()) {
      return;
    }
    setInvitePanelMode(mode);
    resetInvitePanelForm(mode);
    setOpenPermissionTooltip(null);

    if (mode === 'assignee') {
      void Promise.all([fetchTeamData(), fetchAssignees()]);
    }
  };

  const toggleMemberRole = (roleId: number, checked: boolean) => {
    setMemberSelectedRoleIds((prev) => {
      if (checked) {
        if (prev.includes(roleId)) {
          return prev;
        }
        return [...prev, roleId];
      }
      return prev.filter((id) => id !== roleId);
    });
  };

  const handleChangePlan = async () => {
    try {
      const variant = checkGate(PRICING_TABLE_PLANS_GATE) ? 'new' : 'old';
      const session = await changeSubscriptionPlan(managedAccountId, variant);

      if (session?.url) {
        window.location.href = session.url;
        return;
      }

      const errorMessage = extractApiErrorMessage(session?.error) || session?.message;
      showErrorToast(errorMessage || 'Unable to open change plan page.');
    } catch (error) {
      const errorMessage = extractApiErrorMessage(error);
      showErrorToast(errorMessage || 'Unable to open change plan page.');
    }
  };

  const handleRemoveInactiveMembers = async () => {
    if (!ensureCanManageTeamMembers()) {
      return;
    }
    if (isRemovingInactiveMembers || resendingInvitationId || deletingInvitationId) {
      return;
    }
    if (pendingInvitations.length === 0) {
      showToast('There is no inactive members');
      return;
    }

    try {
      setIsRemovingInactiveMembers(true);
      const results = await Promise.allSettled(
        pendingInvitations.map((invitation) =>
          updateAccount({
            accountId: invitation.accountId,
            type: 'unsubscribed',
          })
        )
      );

      const failedCount = results.filter((result) => result.status === 'rejected').length;
      const successCount = results.length - failedCount;

      await Promise.all([fetchTeamData(), loadSeatUsage()]);

      if (failedCount > 0) {
        showErrorToast('Failed to remove some inactive members. Please try again later.');
        return;
      }

      const message =
        successCount === 1
          ? '1 inactive member removed.'
          : `${successCount} inactive members removed.`;
      showSuccessToast(message);
    } catch (error) {
      showErrorToast('Failed to remove inactive members. Please try again later.');
    } finally {
      setIsRemovingInactiveMembers(false);
    }
  };

  const isInvitationActionDisabled = (): boolean => {
    return !!deletingInvitationId || !!resendingInvitationId || isRemovingInactiveMembers;
  };

  const handleAssigneeLabelChange = (value: string) => {
    const normalizedLabel = normalizeAssigneeLabelInput(value);
    setAssigneeLabel(normalizedLabel);
    setIsAssigneeLabelAuto(false);
  };

  const toggleAssigneeRole = (roleId: number, checked: boolean) => {
    setAssigneeSelectedRoleIds((prev) => {
      if (checked) {
        if (prev.includes(roleId)) {
          return prev;
        }
        return [...prev, roleId];
      }
      return prev.filter((id) => id !== roleId);
    });
  };

  const getUniqueAssigneeLabel = (name: string): string =>
    generateUniqueAssigneeLabel(name, getUsedAssigneeLabels());

  const handleAssigneeNameChange = (value: string) => {
    setAssigneeName(value);
    if (isAssigneeLabelAuto) {
      setAssigneeLabel(getUniqueAssigneeLabel(value));
    }
  };

  const handleOpenInvitePanel = (mode: InvitePanelMode, role?: any) => {
    if (!ensureCanManageTeamMembers()) {
      return;
    }
    setInvitePanelMode(mode);
    resetInvitePanelForm(mode);
    setOpenTablePermissionTooltip(null);
    setTablePermissionTooltipPosition(null);
    setIsInvitePanelOpen(true);
    setMemberSelectedRoleIds([role?.id]);
    setAssigneeSelectedRoleIds([role?.id]);

    if (mode === 'assignee') {
      void Promise.all([fetchTeamData(), fetchAssignees()]);
    }
  };

  const handleUpdateTeamMember = async (val: any, member: any, role: any) => {
    if (!member) return;
    if (!role) return;

    let memberRoles: any[] = [];
    if (val) {
      memberRoles = [...new Set([...(member?.roles || []), role?.id])];
    } else if (member?.roles?.length > 0) {
      memberRoles = member?.roles?.filter((f: any) => f !== role?.id);
    }

    const newTeamMembers = teamMembers?.map((i) => {
      if (i?.userId === member?.userId) {
        return {
          ...i,
          roles: memberRoles,
        };
      }
      return i;
    });

    setTeamMembers(newTeamMembers);

    let payload = {
      accountId: member?.accountId,
      roles: memberRoles,
    };

    if (props.handleUpdateTeamMembers) {
      props.handleUpdateTeamMembers(newTeamMembers);
    }

    const res = await updateAccount(payload);
    if (!res) {
      console.error('Error while updating Account');
    }
  };

  const handleUpdateAssignee = async (val: any, assignee: any, role: any) => {
    if (!assignee) return;
    if (!role) return;
    if (!assigneeScopeAccountId) {
      showErrorToast('Account not found.');
      return;
    }

    const previousRoleIds = Array.isArray(assignee?.roles) ? [...assignee.roles] : [];
    const nextRoleIds = val
      ? [...new Set([...(assignee?.roles || []), role?.id])]
      : (assignee?.roles || []).filter((roleId: any) => roleId !== role?.id);

    setAssigneesWithoutLogin((currentAssignees) =>
      currentAssignees.map((currentAssignee) =>
        currentAssignee.id === assignee.id
          ? { ...currentAssignee, roles: [...nextRoleIds] }
          : currentAssignee
      )
    );

    try {
      await editAssignee({
        accountId: assigneeScopeAccountId,
        id: assignee.id,
        roles: [...nextRoleIds],
      });
    } catch (error) {
      setAssigneesWithoutLogin((currentAssignees) =>
        currentAssignees.map((currentAssignee) =>
          currentAssignee.id === assignee.id
            ? { ...currentAssignee, roles: previousRoleIds }
            : currentAssignee
        )
      );
      showErrorToast('Failed to update assignee roles. Please try again later.');
    }
  };

  const handleChangeSeatQty = (e: ChangeEvent<HTMLInputElement>) => {
    let { value } = e.target;

    let numberRegex = /^[1-9]\d*$/;
    if (value && !numberRegex.test(value)) return;

    setSeatState((prev) => {
      return {
        ...prev,
        quantity: value,
      };
    });
  };

  const handleOpenSeatsModal = async (val: boolean) => {
    setOpenSeatsModal(val);
    setIsInvitePanelOpen(false);
    if (val) {
      setSeatLoading(true);
      const res = await getSeatInfo(propsRef?.current?.accountId);
      if (res) {
        let defaultIntervalPrice: any = res?.prices?.data?.find(
          (i: any) => i?.recurring?.interval === seatState.interval
        );
        let unit_amount = defaultIntervalPrice?.unit_amount || 0;
        let defaultIntervalCost = unit_amount / 100 || 0;

        setAvailableSeats(res);
        setSeatState((prev) => {
          return {
            ...prev,
            cost: defaultIntervalCost?.toFixed(2),
          };
        });
        setSeatLoading(false);
      }
    } else {
      setAvailableSeats(null);
      setSeatState(initialSeatState);
      setSeatLoading(false);
    }
  };

  const handleChangeInterval = (val: string) => {
    setSeatState((prev) => ({ ...prev, interval: val }));
    let foundInterval = availableSeats?.prices?.data?.find(
      (i: any) => i?.recurring?.interval === val
    );
    let unit_amount = foundInterval?.unit_amount || 0;
    let newCost = unit_amount / 100 || 0;
    setSeatState((prev) => {
      return {
        ...prev,
        cost: newCost?.toFixed(2),
      };
    });
  };

  const handleBuyMoreSeats = async () => {
    setSeatLoading(true);
    let priceObj = availableSeats?.prices?.data?.find(
      (i: any) => i?.recurring?.interval === seatState.interval
    );
    let payload = {
      accountId: propsRef?.current?.accountId,
      quantity: Number(seatState.quantity) || 1,
      seat: priceObj,
    };
    const res = await buyAdditionalSeats(payload);
    if (res) {
      setOpenSeatsModal(false);
      setSeatState(initialSeatState);
      await Promise.all([fetchTeamData(), loadSeatUsage()]);
      setSeatLoading(false);
    }
  };
  // ####### END OF FUNCTIONS #######

  // ####### FETCH FUNCTIONS #######
  const fetchRoles = async () => {
    if (!managedAccountId) {
      setRoles([]);
      return;
    }

    try {
      const roles = await loadRolesForAccount(managedAccountId);

      setRoles(roles);
    } catch (error) {
      showErrorToast('Failed to fetch roles. Please try again later.');
    }
  };

  useEffect(() => {
    if (!managedAccountId || !canUseRoleAssignments) {
      return;
    }
    fetchRoles();
    loadSeatUsage();
  }, [canUseRoleAssignments, managedAccountId, refetchRoles]);

  useEffect(() => {
    if (!managedAccountId || !canUseRoleAssignments || !props.accountUser) {
      return;
    }
    void fetchTeamData(props.accountUser);
  }, [canUseRoleAssignments, managedAccountId, props.accountUser]);

  const handleResetAllFilters = () => {
    updateState({
      pageNumber: 1,
      filters: {
        client: { value: [], archived: false },
        status: { value: [] },
        estimate: { value: [] },
        invoice: { value: [] },
        items: { value: [] },
        assignee: { value: [] },
      },
      filtersDraft: {
        client: { value: [], archived: false },
        status: { value: [] },
        estimate: { value: [] },
        invoice: { value: [] },
        items: { value: [] },
        assignee: { value: [] },
      },
    });
  };

  const handleColumnVisibilityChange = (next: ProjectOverviewColumnVisibility) => {
    const resolvedNext = resolveColumnVisibility(next);
    updateState({ columnVisibility: resolvedNext });
    void upsertColumnVisibilityPreference({
      accountId: props.accountId,
      page: COLUMN_VISIBILITY_PAGES.items,
      visibility: { columns: resolvedNext },
    }).catch((error) => {
      console.error('Failed to save column visibility preferences for items page:', error);
    });
  };

  const handleSaveCustomColumns = async (customColumns: CustomColumnPreference[]) => {
    if (!props.accountId) {
      return;
    }

    const response = await saveCustomColumnsPreference({
      accountId: props.accountId,
      page: COLUMN_VISIBILITY_PAGES.items,
      customColumns,
    });

    setCustomColumnsConfig(
      Array.isArray(response?.visibility?.customColumns)
        ? response.visibility.customColumns
        : customColumns
    );
  };

  const persistProjectCustomColumnValue = useCallback(
    async (project: any, columnId: CustomColumnId, value: string) => {
      if (!project || !columnId) {
        return false;
      }

      const nextProject = {
        ...project,
        customColumnsValues: writeCustomColumnValue(project?.customColumnsValues, columnId, value),
      };

      updateProjects([nextProject]);
      return true;
    },
    [updateProjects]
  );

  const handleRoleColumnVisibilityChange = (next: Record<number, boolean>) => {
    setRoleColumnVisibility(next);
    void upsertColumnVisibilityPreference({
      accountId: props.accountId,
      page: COLUMN_VISIBILITY_PAGES.items,
      visibility: { assignmentColumns: next },
    }).catch((error) => {
      console.error('Failed to save assignment column visibility for items page:', error);
    });
  };

  const handleResetAllFiltersDraft = () => {
    updateState({
      filtersDraft: {
        client: { value: [], archived: false },
        status: { value: [] },
        estimate: { value: [] },
        invoice: { value: [] },
        items: { value: [] },
        assignee: { value: [] },
      },
    });
  };

  const handleApplyFilters = () => {
    updateState((prev) => ({
      pageNumber: 1,
      filters: {
        client: {
          ...prev.filters.client,
          value: [...(prev.filtersDraft.client?.value || [])],
          archived: prev.filtersDraft.client?.archived ?? prev.filters.client.archived,
        },
        status: { value: [...(prev.filtersDraft.status?.value || [])] },
        estimate: { value: [...(prev.filtersDraft.estimate?.value || [])] },
        invoice: { value: [...(prev.filtersDraft.invoice?.value || [])] },
        items: { value: [...(prev.filtersDraft.items?.value || [])] },
        assignee: { value: [...(prev.filtersDraft.assignee?.value || [])] },
      },
    }));
  };

  const handleSaveComponents = async (components: any) => {
    for (const c of components) {
      await editDraperyOrderSummaryComponent(c);
    }
  };

  const handleShowArchivedChecked = (checked: boolean) => {
    onShowArchiveChange(checked);
  };

  const handleRefetchRoles = () => {
    setRefetchRoles((prev) => !prev);
  };

  const numberDelete = useMemo(
    () =>
      state.projectList.filter((project) => state.checkedProjects.includes(project.itemId)).length,
    [state.projectList, state.checkedProjects]
  );

  const estimate_map = useMemo(
    () => [
      { name: 'Not Created', value: 'Not Created' },
      { name: 'Created', value: 'Created' },
      { name: 'Exported to QB', value: 'Exported to QB' },
      { name: 'Sent to Customer', value: 'Sent to Customer' },
    ],
    []
  );

  const invoice_map = useMemo(
    () => [
      { name: 'Not Created', value: 'Not Created' },
      { name: 'Not Paid', value: 'Not Paid' },
      { name: 'Partial', value: 'Partial' },
      { name: 'Paid', value: 'Paid' },
    ],
    []
  );

  const itemsMap = useMemo(
    () =>
      buildItemTypeFilterOptions(state.items || []).map((item) => ({
        name: item,
        value: item,
      })),
    [state.items]
  );

  const assigneeFilterItems = useMemo(
    () =>
      buildRoleAssignmentFilterOptions(
        canUseRoleAssignments ? roleAssignmentColumns : [],
        assignmentOptionsByRoleId
      ).map((option) => ({
        name: option.label,
        label: option.label,
        value: option.value,
      })),
    [canUseRoleAssignments, roleAssignmentColumns, assignmentOptionsByRoleId]
  );

  const visibleRoleAssignmentColumns = useMemo(
    () =>
      canUseRoleAssignments
        ? roleAssignmentColumns.filter((role) => roleColumnVisibility[role.id] !== false)
        : [],
    [canUseRoleAssignments, roleAssignmentColumns, roleColumnVisibility]
  );

  const isFiltersActivate = useMemo(
    () =>
      (state.filters.client.value && state.filters.client.value.length > 0) ||
      (state.filters.status.value && state.filters.status.value.length > 0) ||
      (state.filters.estimate.value && state.filters.estimate.value.length > 0) ||
      (state.filters.invoice.value && state.filters.invoice.value.length > 0) ||
      (state.filters.items.value && state.filters.items.value.length > 0) ||
      (canUseRoleAssignments &&
        state.filters.assignee.value &&
        state.filters.assignee.value.length > 0),
    [canUseRoleAssignments, state.filters]
  );

  const activeFiltersCount = useMemo(() => {
    let count = 0;

    const keys: Array<'client' | 'items' | 'assignee' | 'status' | 'estimate' | 'invoice'> =
      canUseRoleAssignments
        ? ['client', 'items', 'assignee', 'status', 'estimate', 'invoice']
        : ['client', 'items', 'status', 'estimate', 'invoice'];

    keys.forEach((key) => {
      const temp = state.filtersDraft?.[key]?.value;
      if (temp && temp.length > 0) {
        count += 1;
      }
    });

    return count;
  }, [canUseRoleAssignments, state.filtersDraft]);

  const drawerFilters = {
    onResetAll: handleResetAllFiltersDraft,
    onApply: handleApplyFilters,
    activeFilters: activeFiltersCount,
    isMobile: true,
    disabled: false,
    isFiltersActivate: isFiltersActivate,
    filters: [
      {
        shadcn: true,
        filter_name: 'Clients',
        filter_key: 'client',
        filter_values: state.filtersDraft.client.value[0]
          ? [state.filtersDraft.client.value[0]]
          : [],
        multiple_select: false,
        dataQaPrefix: 'overview',
        items:
          state.clients &&
          state.clients.length > 0 &&
          state.clients
            .filter((i) => (state.filtersDraft.client.archived ? 1 : i.active))
            .filter((i) => !i.parent),
        archived: false,
        show_option_all: true,
        max_depth: 1,
        handleClearAllFilter: handleClearAllFilterDraft,
        handleChooseFilter: handleChooseFilterDraft,
        handleShowArchived: handleShowArchived,
      },
      {
        shadcn: true,
        filter_name: 'Items',
        filter_key: 'items',
        filter_values: state.filtersDraft.items.value,
        multiple_select: true,
        dataQaPrefix: 'overview',
        items: itemsMap,
        archived: true,
        archivedCheckbox: state.showArchived,
        archivedProjectsFunction: true,
        show_option_all: false,
        handleClearAllFilter: handleClearAllFilterDraft,
        handleChooseFilter: handleChooseFilterDraft,
        handleShowArchived: onShowArchiveChange,
      },
      ...(canUseRoleAssignments
        ? [
            {
              shadcn: true,
              filter_name: 'Assignee',
              filter_key: 'assignee',
              filter_values: state.filtersDraft.assignee.value,
              multiple_select: true,
              dataQaPrefix: 'overview',
              items: assigneeFilterItems,
              archived: false,
              show_option_all: false,
              handleClearAllFilter: handleClearAllFilterDraft,
              handleChooseFilter: handleChooseFilterDraft,
              handleShowArchived: () => {},
            },
          ]
        : []),
      {
        shadcn: true,
        filter_name: 'Status',
        filter_key: 'status',
        filter_values: state.filtersDraft.status.value,
        multiple_select: true,
        dataQaPrefix: 'overview',
        items: state.accountStatuses,
        archived: false,
        show_option_all: false,
        new_status_option: true,
        newStatusFilterValue: state.newStatusFilterValue,
        newStatusFilter: state.newStatusFilter,
        handleClearAllFilter: handleClearAllFilterDraft,
        handleChooseFilter: handleChooseFilterDraft,
        handleShowArchived: () => {},
        handleChangeNewStatusFilter: handleChangeNewStatusFilter,
        handleSetNewStatusFilter: handleSetNewStatusFilter,
        handleSaveNewStatus: handleSaveNewStatus,
        newStatusRef: newStatusRef,
        handleResetNewStatus: handleResetNewStatus,
      },
      {
        shadcn: true,
        filter_name: 'Estimate',
        filter_key: 'estimate',
        filter_values: state.filtersDraft.estimate.value,
        multiple_select: true,
        dataQaPrefix: 'overview',
        dataQaItemType: 'name',
        items: estimate_map,
        archived: false,
        show_option_all: false,
        handleClearAllFilter: handleClearAllFilterDraft,
        handleChooseFilter: handleChooseFilterDraft,
        handleShowArchived: () => {},
      },
      {
        shadcn: true,
        filter_name: 'Invoice',
        filter_key: 'invoice',
        filter_values: state.filtersDraft.invoice.value,
        multiple_select: true,
        dataQaPrefix: 'overview',
        dataQaItemType: 'name',
        items: invoice_map,
        archived: false,
        show_option_all: false,
        handleClearAllFilter: handleClearAllFilterDraft,
        handleChooseFilter: handleChooseFilterDraft,
        handleShowArchived: () => {},
      },
    ],
  };

  return (
    <>
      {/* wrapper */}
      <PageContent
        // className="md:m-[24px] m-[12px] flex flex-1 flex-col min-w-0 max-w-full overflow-x-hidden"
        data-qa="overview-page"
      >
        {/* wrapper */}
        <div>
          {/* wrapper */}
          <div>
            {/* wrapper - className="md:m-[24px] m-[12px] flex flex-1 flex-col min-w-0 max-w-full overflow-x-hidden" */}
            <div>
              <div className="flex flex-col w-full overflow-visible pr-[10px]">
                <header
                  className="flex items-center justify-between md:gap-[10px] gap-[5px] md:flex-nowrap flex-wrap md:-mt-[4px] -mt-[2px]"
                  data-qa="overview-header"
                >
                  <div className="flex flex-1 items-center pr-2.5">
                    <h1
                      className="mr-4 md:text-[24px] text-[16px] font-medium text-[#222222]"
                      style={{ fontFamily: 'Poppins, serif' }}
                      data-qa="overview-title"
                    >
                      Items ({state.ordersLength})
                    </h1>

                    <Label
                      htmlFor="overview-show-archived"
                      className="ml-2 flex items-center gap-2 text-sm font-normal text-[#222222]"
                      data-qa="overview-show-archived"
                    >
                      <Checkbox
                        id="overview-show-archived"
                        checked={state.showArchived}
                        onCheckedChange={(checked) => handleShowArchivedChecked(checked === true)}
                        data-qa="overview-show-archived-checkbox"
                      />
                      <span>Show archived</span>
                    </Label>
                  </div>

                  <div className="relative z-[99] flex w-[600px]! flex-col" ref={submenuRef}>
                    {state.accountCanSeePricing && (
                      <Button
                        className="ml-auto h-10 w-[138px] rounded-md text-sm"
                        onClick={() => {
                          let draperyItem: any = localStorage.getItem('romanShadeItem');
                          if (draperyItem) {
                            draperyItem = JSON.parse(draperyItem);
                          } else {
                            draperyItem = {};
                          }

                          delete draperyItem.orderId;
                          delete draperyItem.client;

                          localStorage.setItem('romanShadeItem', JSON.stringify(draperyItem));

                          updateState((prev) => ({
                            isSubmenuOpened: !prev.isSubmenuOpened,
                          }));
                        }}
                        data-qa="overview-add-item-button"
                      >
                        <AddIcon className="size-4" />
                        Add Item
                      </Button>
                    )}

                    {state.accountCanSeePricing && state.isSubmenuOpened && (
                      <div
                        // className={cn(
                        //   'absolute right-0 top-full z-[999] mt-1 flex min-w-[220px] flex-col overflow-hidden rounded-md border border-[#e5e7eb] bg-white shadow-[0px_10px_14px_8px_#00000026,0_6px_5px_rgba(0,0,0,0.3)]',
                        //   showNewBadge ? 'w-[200px]' : 'w-[138px]'
                        // )}
                        className="add_item_submenu"
                        data-qa="overview-add-item-menu"
                      >
                        <div>
                          <Button
                            variant="ghost"
                            className="h-10 w-full justify-start rounded-none px-4 text-sm text-[#747474] hover:bg-[#e2e8f0]"
                            onClick={() => handleNewClientProject('drapery-order')}
                            data-qa="overview-add-item-drapery"
                          >
                            Drapery
                          </Button>

                          <Button
                            variant="ghost"
                            className="h-10 w-full justify-between rounded-none px-4 text-sm text-[#747474] hover:bg-[#e2e8f0]"
                            onClick={() => handleNewClientProject('roman-shade-order')}
                            data-qa="overview-add-item-roman-shade"
                          >
                            <span className="whitespace-nowrap">Roman Shade</span>
                          </Button>

                          <Button
                            variant="ghost"
                            className="h-10 w-full justify-between rounded-none px-4 text-sm text-[#747474] hover:bg-[#e2e8f0]"
                            onClick={() => props.handleShowBottomSheet(true)}
                            data-qa="overview-add-item-purchased-goods"
                          >
                            <span>Purchased Goods</span>
                            {showNewBadge ? <span className="new_pill">New</span> : null}
                          </Button>

                          <Button
                            variant="ghost"
                            className="h-10 w-full justify-start rounded-none px-4 text-sm text-[#747474] hover:bg-[#e2e8f0]"
                            onClick={() => handleNewClientProject('custom-order')}
                            data-qa="overview-add-item-other"
                          >
                            Other
                          </Button>

                          {checkGate(QUIPA_ASSISTANT_CREATE_PROJECT_GATE) && (
                            <>
                              <div className="my-1 h-px bg-[#e5e7eb]" />
                              <Button
                                variant="ghost"
                                className="h-auto w-full justify-start whitespace-normal rounded-none px-4 py-2.5 text-left text-sm leading-snug text-[#747474] hover:bg-[#e2e8f0]"
                                onClick={() => {
                                  updateState({ isSubmenuOpened: false });
                                  openQuipaAssistant({ source: 'overview' });
                                }}
                                data-qa="overview-add-item-assistant"
                              >
                                Start New Project with QUIPA Assistant
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </header>

                <div
                  className="flex items-center gap-2 flex-wrap md:py-[10px] py-[4px]"
                  data-qa="overview-filters"
                >
                  <InputGroup className="max-w-xs inline-flex w-full">
                    <InputGroupInput
                      id="overview_search_input"
                      ref={searchInputRef}
                      value={state.searchTerm || ''}
                      onChange={(e) => handleChangeValueSearchInput(e)}
                      onKeyDown={handleSearchInputKeyDown}
                      placeholder="Search..."
                      className="placeholder:font-normal"
                      data-qa="overview-search-input"
                    />
                    <InputGroupAddon className="inline-flex">
                      {state.searchTerm ? (
                        <CirclePlus
                          id="overview_search_input_clear"
                          data-qa="overview-search-clear"
                          onMouseDown={() => {
                            handleClearSearchKeyword();
                          }}
                          stroke="white"
                          fill="#3b87a0"
                          className="!size-5 text-lg rotate-[45deg] cursor-pointer"
                        />
                      ) : (
                        <Search className="size-4 text-muted-foreground" />
                      )}
                    </InputGroupAddon>
                  </InputGroup>

                  {state.isMobile ? (
                    <div data-qa="overview-filters-drawer">
                      <FiltersDrawer {...drawerFilters} />
                    </div>
                  ) : (
                    <>
                      <div data-qa="overview-filter-clients">
                        <Filter
                          shadcn
                          filter_name={'Clients'}
                          filter_key={'client'}
                          filter_values={
                            state.filters.client.value[0] ? [state.filters.client.value[0]] : []
                          }
                          multiple_select={false}
                          dataQaPrefix="overview"
                          items={
                            state.clients &&
                            state.clients.length > 0 &&
                            state.clients
                              .filter((i) => (state.filters.client.archived ? 1 : i.active))
                              .filter((i) => !i.parent)
                          }
                          archived={false}
                          show_option_all={true}
                          max_depth={1}
                          handleClearAllFilter={handleClearAllFilter}
                          handleChooseFilter={handleChooseFilter}
                          handleShowArchived={handleShowArchived}
                        />
                      </div>

                      <div data-qa="overview-filter-items">
                        <Filter
                          shadcn
                          filter_name={'Items'}
                          filter_key={'items'}
                          filter_values={state.filters.items.value}
                          multiple_select={true}
                          dataQaPrefix="overview"
                          items={itemsMap}
                          archived={false}
                          archivedCheckbox={state.showArchived}
                          archivedProjectsFunction={true}
                          show_option_all={false}
                          handleClearAllFilter={handleClearAllFilter}
                          handleChooseFilter={handleChooseFilter}
                          handleShowArchived={onShowArchiveChange}
                        />
                      </div>

                      {canUseRoleAssignments && (
                        <div data-qa="overview-filter-assignee">
                          <Filter
                            shadcn
                            filter_name={'Assignee'}
                            filter_key={'assignee'}
                            filter_values={state.filters.assignee.value}
                            multiple_select={true}
                            dataQaPrefix="overview"
                            items={assigneeFilterItems}
                            archived={false}
                            show_option_all={false}
                            handleClearAllFilter={handleClearAllFilter}
                            handleChooseFilter={handleChooseFilter}
                            handleShowArchived={() => {}}
                          />
                        </div>
                      )}

                      <div data-qa="overview-filter-status">
                        <Filter
                          shadcn
                          filter_name={'Status'}
                          filter_key={'status'}
                          filter_values={state.filters.status.value}
                          multiple_select={true}
                          dataQaPrefix="overview"
                          items={state.accountStatuses}
                          archived={false}
                          show_option_all={false}
                          new_status_option={true}
                          newStatusFilterValue={state.newStatusFilterValue}
                          newStatusFilter={state.newStatusFilter}
                          handleClearAllFilter={handleClearAllFilter}
                          handleChooseFilter={handleChooseFilter}
                          handleShowArchived={() => {}}
                          handleChangeNewStatusFilter={handleChangeNewStatusFilter}
                          handleSetNewStatusFilter={handleSetNewStatusFilter}
                          handleSaveNewStatus={handleSaveNewStatus}
                          newStatusRef={newStatusRef}
                          handleResetNewStatus={handleResetNewStatus}
                        />
                      </div>

                      <div data-qa="overview-filter-estimate">
                        <Filter
                          shadcn
                          filter_name={'Estimate'}
                          filter_key={'estimate'}
                          filter_values={state.filters.estimate.value}
                          multiple_select={true}
                          dataQaPrefix="overview"
                          dataQaItemType="name"
                          items={estimate_map}
                          archived={false}
                          show_option_all={false}
                          handleClearAllFilter={handleClearAllFilter}
                          handleChooseFilter={handleChooseFilter}
                          handleShowArchived={() => {}}
                        />
                      </div>

                      <div data-qa="overview-filter-invoice">
                        <Filter
                          shadcn
                          filter_name={'Invoice'}
                          filter_key={'invoice'}
                          filter_values={state.filters.invoice.value}
                          multiple_select={true}
                          dataQaPrefix="overview"
                          dataQaItemType="name"
                          items={invoice_map}
                          archived={false}
                          show_option_all={false}
                          handleClearAllFilter={handleClearAllFilter}
                          handleChooseFilter={handleChooseFilter}
                          handleShowArchived={() => {}}
                        />
                      </div>
                    </>
                  )}

                  {isFiltersActivate && (
                    <Button
                      variant="resetFilters"
                      type="button"
                      onClick={() => handleResetAllFilters()}
                      data-qa="overview-filters-clear"
                    >
                      <LucideX />
                      Clear All
                    </Button>
                  )}

                  <div data-qa="overview-column-visibility">
                    <ColumnVisibilityMenu
                      value={state.columnVisibility}
                      onChange={handleColumnVisibilityChange}
                      preserveOnHideAll={['client', 'item']}
                      dataQaPrefix="overview"
                      enableCustomColumns
                      showCustomFieldsSection
                      canCustomizeCustomColumns={canCustomizeCustomColumns}
                      initialCustomColumns={customColumnsConfig}
                      onSaveCustomColumns={handleSaveCustomColumns}
                      hiddenKeys={hiddenColumnKeys}
                      roleAssignmentColumns={roleAssignmentColumns}
                      roleColumnVisibility={roleColumnVisibility}
                      onRoleColumnVisibilityChange={handleRoleColumnVisibilityChange}
                      isAccountAdmin={state.accountIsAdmin}
                      account={account}
                      handleRefetchRoles={handleRefetchRoles}
                      teamMembers={teamMembers}
                      assignees={assigneesWithoutLogin}
                      handleUpdateTeamMember={handleUpdateTeamMember}
                      handleUpdateAssignee={handleUpdateAssignee}
                      unsetRoleColumns={unsetRoleColumns}
                      handleOpenInvitePanel={handleOpenInvitePanel}
                      canAccessTeamSettings={props.canAccessTeamSettings}
                    />
                  </div>
                </div>

                {/* <div className="md:mt-[4px] mt-[2px]"> */}
                <>
                  {state.isFetched ? (
                    <div data-qa="overview-loader">
                      <FadeLoader
                        style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(50%,-50%)',
                          zIndex: 9999,
                          display: !state.isFetched ? 'none' : 'block',
                        }}
                        color="#3B97B1"
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    </div>
                  ) : (
                    // <div>
                    <>
                      {/* <div
                    className={cn(
                      // 'h-[calc(100vh-330px)] w-full max-w-full min-w-0 flex-col overflow-hidden pr-2.5 transition-all duration-300 transform-gpu min-[520px]:h-[calc(100vh-310px)] min-[633px]:h-[calc(100vh-260px)] min-[769px]:h-[calc(100vh-380px)] min-[778px]:h-[calc(100vh-330px)] min-[1459px]:h-[calc(100vh-300px)]',
                      // state.displayContent ? 'scale-100 opacity-100' : 'scale-90 opacity-0'
                      'md:max-h-unset md:h-full',
                      state.displayContent ? 'scale-100 opacity-100' : 'scale-90 opacity-0'
                    )}
                    onScroll={onAreaScroll}
                    data-qa="overview-table-container"
                  > */}
                      <PopoverScrollContext.Provider value={state.areaScrollInfo}>
                        <ConfirmationModal
                          uiActive={state.isModalOpen && state.value === 'Duplicate'}
                          uiOnConfirm={() => handleProjectAction('Duplicate')}
                          uiOnClose={() => {
                            updateState({
                              isModalOpen: false,
                              value: '',
                            });
                          }}
                          uiOnRequestClose={() => {
                            updateState({
                              isModalOpen: false,
                              value: '',
                            });
                          }}
                          uiCloseOnOutsideClick={true}
                          uiCloseOnEsc={true}
                        >
                          <p>
                            {`Are you sure you want to duplicate ${numberDelete} ${
                              numberDelete === 1 ? 'item' : 'items'
                            }?`}
                          </p>
                        </ConfirmationModal>
                        <ConfirmationModal
                          uiActive={state.isModalOpen && state.value === 'Delete'}
                          uiOnConfirm={() => handleProjectAction('Delete')}
                          uiOnClose={() => {
                            updateState({
                              isModalOpen: false,
                              value: '',
                            });
                          }}
                          uiOnRequestClose={() => {
                            updateState({
                              isModalOpen: false,
                              value: '',
                            });
                          }}
                          uiCloseOnOutsideClick={true}
                          uiCloseOnEsc={true}
                        >
                          <p>
                            {`Are you sure you want to delete ${numberDelete} ${
                              numberDelete === 1 ? 'item' : 'items'
                            }?`}
                          </p>
                        </ConfirmationModal>
                        <ConfirmationModal
                          uiActive={state.isModalOpen && state.value === 'Archive'}
                          uiOnConfirm={() => handleProjectAction('Archive')}
                          uiOnClose={() => {
                            updateState({
                              isModalOpen: false,
                              value: '',
                            });
                          }}
                          uiOnRequestClose={() => {
                            updateState({
                              isModalOpen: false,
                              value: '',
                            });
                          }}
                          uiCloseOnOutsideClick={true}
                          uiCloseOnEsc={true}
                        >
                          <p>
                            {`Are you sure you want to archive ${numberDelete} ${
                              numberDelete === 1 ? 'item' : 'items'
                            }?`}
                          </p>
                        </ConfirmationModal>
                        <WarningModal
                          uiActive={state.isModalOpen && state.value === 'DuplicateBlocked'}
                          uiOnConfirm={() => {
                            updateState({
                              isModalOpen: false,
                              value: '',
                            });
                          }}
                          uiOnRequestClose={() => {
                            updateState({
                              isModalOpen: false,
                              value: '',
                            });
                          }}
                          uiCloseOnOutsideClick={true}
                          uiCloseOnEsc={true}
                          uiHeader="Cannot Duplicate"
                        >
                          <p>
                            {`Some options selected on this Roman Shade Order form are no longer available in our updated form. This order is unable to be duplicated; please create a new order instead.`}
                          </p>
                        </WarningModal>
                        {state.generatePdf && (
                          <div
                            className="fixed inset-0 z-[100000000]"
                            data-qa="overview-generate-pdf-loader"
                          >
                            <FadeLoader
                              style={{
                                position: 'fixed',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(50%,-50%)',
                                zIndex: 100000000,
                                display: !state.generatePdf ? 'none' : 'block',
                              }}
                              color="#3B97B1"
                              aria-label="Loading Spinner"
                              data-testid="loader"
                            />
                          </div>
                        )}

                        <div data-qa="overview-table">
                          <ProjectOverviewTable
                            projectList={state.projectList}
                            roomList={state.roomList}
                            checkedProjects={state.checkedProjects}
                            showArchived={state.showArchived}
                            columnVisibility={state.columnVisibility}
                            isParent={true}
                            onNewClientProject={handleNewClientProject}
                            onCheckAllRows={checkAllRows}
                            onCheckRow={checkRow}
                            onItemColumnClick={handleProjectItemClicked}
                            canOpenItems={state.accountCanSeePricing}
                            canManageActions={state.accountCanSeePricing}
                            accountIsAdmin={state.accountIsAdmin}
                            roleAssignmentColumns={visibleRoleAssignmentColumns}
                            assignmentOptionsByRoleId={assignmentOptionsByRoleId}
                            customColumns={visibleCustomColumns}
                            onCustomColumnValueChange={persistProjectCustomColumnValue}
                            onWorkOrderColumnClick={handleProjectWorkOrderNumClicked}
                            onEdited={updateProjects}
                            updateNotebook={updateNotebook}
                            onActionSelected={handleProjectAction}
                            onShowArchiveChange={onShowArchiveChange}
                            onOpenModal={onOpenModal}
                            handleNotCheckedBatchRow={handleNotCheckedBatchRow}
                            onClientClick={handleClientClicked}
                            client={state.client}
                            clients={state.clients}
                            editProjectItem={editProjectItem}
                            mapSortTableToSortOptions={mapSortTableToSortOptions}
                            overviewPage={true}
                            loadProjects={loadProjects}
                            borderBottom
                            paddingBottom
                            searchTerm={state.searchHighlightWord}
                            pageLoading={state.pageLoading}
                            handleEstimate={handleEstimate}
                            onOpenEstimate={handleOpenEstimateFromStatus}
                            isConnected={props.isConnected}
                            isFiltersActivate={isFiltersActivate}
                            handleSaveComponents={handleSaveComponents}
                            handleResetAllFilters={handleResetAllFilters}
                            tableStatuses={state.accountStatuses}
                            handleTriggerRefetch={handleTriggerRefetch}
                            handleTriggerProjectRefetch={handleTriggerProjectRefetch}
                            handlePrint={handlePrint}
                            isPrintModalOpen={state.isPrintModalOpen}
                            openPrintModal={handlePrintModal}
                            handleOpenSinglePurchasedGoods={props.handleOpenSinglePurchasedGoods}
                            projectRefetch={state.projectRefetch}
                            purchasedGoodsRefetch={props.purchasedGoodsRefetch}
                            accountUser={props.accountUser}
                            canAccessTeamSettings={props.canAccessTeamSettings}
                            handleOpenInvitePanel={handleOpenInvitePanel}
                            roleAssignmentTeamMembers={teamMembers}
                            roleAssignmentAssignees={assigneesWithoutLogin}
                            handleUpdateTeamMember={handleUpdateTeamMember}
                            handleUpdateAssignee={handleUpdateAssignee}
                            backToTop={props.backToTop}
                            pageScrollTo={props.pageScrollTo}
                          />
                        </div>

                        <EstimateBuilderSheet
                          open={estimateSheetState.open}
                          initialMode="view"
                          estimateId={estimateSheetState.estimateId}
                          clientId={estimateSheetState.client?.id}
                          accountId={props.accountId}
                          client={estimateSheetState.client}
                          account={account}
                          accountUser={props.accountUser}
                          qboConnected={estimateSheetState.qboConnected}
                          existingEstimates={estimateSheetState.estimates}
                          onClose={handleCloseEstimateSheet}
                          onChanged={handleEstimateSheetChanged}
                          singleUser={!props.canAccessTeamSettings}
                        />

                        <LoadingModal
                          message="Creating work order..."
                          isModalOpen={state.isLoadingOpen}
                          onModalClose={toggleLoadingModal}
                        />

                        {state.duplicateLoading && (
                          <div
                            className="fixed inset-0 z-[9999]"
                            data-qa="overview-duplicate-loader"
                          >
                            <FadeLoader
                              style={{
                                position: 'fixed',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(50%,-50%)',
                                zIndex: 9999,
                                display: !state.duplicateLoading ? 'none' : 'block',
                              }}
                              color="#3B97B1"
                              aria-label="Loading Spinner"
                              data-testid="loader"
                            />
                          </div>
                        )}

                        {state.exportingEstimateLoading && (
                          <div
                            className="fixed inset-0 z-[9999] bg-black/10"
                            data-qa="overview-export-loader"
                          >
                            <FadeLoader
                              style={{
                                position: 'fixed',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                zIndex: 9999,
                              }}
                              color="#3B97B1"
                              aria-label="Loading Spinner"
                              data-testid="export-loader"
                            />
                          </div>
                        )}
                      </PopoverScrollContext.Provider>
                      {/* </div> */}

                      <div
                        className="mr-2.5 flex h-full min-h-[52px] items-center justify-end rounded-b-[0.28rem] border border-[#e2e2e2] px-[33px] py-2.5 pr-[65px]"
                        data-qa="overview-pagination"
                      >
                        <div className="flex h-8 items-center gap-[27px]">
                          <div className="flex items-center justify-center">
                            <span className="font-medium">Rows per page</span>
                          </div>
                          <div className="flex items-center justify-center">
                            <select
                              onChange={(e) => handlePageLimitChange(e)}
                              value={state.pageLimit}
                              className={paginationSelectClassName}
                              data-qa="overview-pagination-select"
                            >
                              <option value={10} data-qa="overview-pagination-option-10">
                                10
                              </option>
                              <option value={25} data-qa="overview-pagination-option-25">
                                25
                              </option>
                              <option value={50} data-qa="overview-pagination-option-50">
                                50
                              </option>
                              <option value={100} data-qa="overview-pagination-option-100">
                                100
                              </option>
                            </select>
                          </div>
                          <div className="flex items-center justify-center">
                            <span>
                              {state.pageNumber > 1
                                ? state.pageLimit * state.pageNumber - (state.pageLimit - 1)
                                : 1}
                              -
                              {state.ordersLength >= state.pageLimit * state.pageNumber
                                ? state.pageLimit * state.pageNumber
                                : state.ordersLength}{' '}
                              of {state.ordersLength}
                            </span>
                          </div>
                          <div className="flex items-center gap-1">
                            <Button
                              variant="ghost"
                              size="icon"
                              disabled={state.pageNumber <= 1 || state.pageLoading}
                              onClick={() => handleFirstPage()}
                              className="h-8 w-8"
                              data-qa="overview-pagination-first"
                            >
                              <PaginationEndIcon
                                className={cn(
                                  'rotate-180',
                                  state.pageNumber <= 1
                                    ? 'opacity-40 cursor-auto'
                                    : 'cursor-pointer'
                                )}
                              />
                            </Button>

                            <Button
                              variant="ghost"
                              size="icon"
                              disabled={state.pageNumber <= 1 || state.pageLoading}
                              onClick={() => handlePrevPage()}
                              className="h-8 w-8"
                              data-qa="overview-pagination-prev"
                            >
                              <PaginationNextIcon
                                className={cn(
                                  'rotate-180',
                                  state.pageNumber <= 1
                                    ? 'opacity-40 cursor-auto'
                                    : 'cursor-pointer'
                                )}
                              />
                            </Button>

                            <Button
                              variant="ghost"
                              size="icon"
                              disabled={state.pageNumber >= state.totalPages || state.pageLoading}
                              onClick={() => handleNextPage()}
                              className="h-8 w-8"
                              data-qa="overview-pagination-next"
                            >
                              <PaginationNextIcon
                                className={cn(
                                  state.pageNumber >= state.totalPages
                                    ? 'opacity-40 cursor-auto'
                                    : 'cursor-pointer'
                                )}
                              />
                            </Button>

                            <Button
                              variant="ghost"
                              size="icon"
                              disabled={state.pageNumber >= state.totalPages || state.pageLoading}
                              onClick={() => handleLastPage()}
                              className="h-8 w-8"
                              data-qa="overview-pagination-last"
                            >
                              <PaginationEndIcon
                                className={cn(
                                  state.pageNumber >= state.totalPages
                                    ? 'opacity-40 cursor-auto'
                                    : 'cursor-pointer'
                                )}
                              />
                            </Button>
                          </div>
                        </div>
                      </div>

                      <EditItemsModal
                        active={state.isEditItemsModalOpen}
                        onRequestClose={editItemModalClose}
                        roomList={state.roomList}
                        onSave={batchEdit}
                        clients={state.clients}
                        handleSearchClient={handleSearchClient}
                        statuses={state.accountStatuses}
                        qboConnected={props.isConnected}
                      />
                    </>
                  )}
                </>
                {/* </div> */}

                <AnnouncementPopup
                  active={state.ripplefoldPopUp}
                  dataQa="overview-popup-ripplefold"
                >
                  <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-4">
                      <div className="flex gap-[21px]">
                        <div className="flex flex-col gap-2.5">
                          <span className="text-[32px] leading-[42px] text-primary">
                            Ripplefold has arrived!
                          </span>
                          <span className="text-[16px] leading-6 font-normal text-[#545454]">
                            We are pleased to announce that QUIPA Drapery Orders will now include an
                            option for Ripplefold!
                          </span>
                        </div>

                        <div className="flex items-center">
                          <Confetti style={{ width: '110px' }} />
                        </div>

                        <div>
                          <Button
                            type="button"
                            variant="ghost"
                            size="icon"
                            className="h-8 w-8"
                            onClick={() => handleCloseRipplefoldPopUp()}
                            data-qa="overview-popup-ripplefold-close"
                          >
                            <PopUpClose />
                          </Button>
                        </div>
                      </div>
                      <div>
                        <p className="text-[16px] leading-6 font-normal text-[#545454]">
                          Please click “Continue” to add Ripplefold pricing (required) and
                          construction settings (recommended) in My Shop.
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center justify-end">
                      <Button
                        type="button"
                        onClick={() => handleOpenMyShop()}
                        data-qa="overview-popup-ripplefold-continue"
                      >
                        Continue
                      </Button>
                    </div>
                  </div>
                </AnnouncementPopup>

                <AnnouncementPopup
                  active={state.romanShadePopUp}
                  dataQa="overview-popup-roman-shade"
                >
                  <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-4">
                      <div className="flex gap-[21px]">
                        <div className="flex flex-col gap-2.5">
                          <span className="text-[32px] leading-[42px] text-primary">
                            Roman Shade Order has arrived!
                          </span>
                          <span className="text-[16px] leading-6 font-normal text-[#545454]">
                            Now you can store item details, create the work order, and track Roman
                            Shades on the Project Overview table.
                          </span>
                        </div>
                        <div className="flex items-center">
                          <Confetti style={{ width: '110px' }} />
                        </div>
                        <div>
                          <Button
                            type="button"
                            variant="ghost"
                            size="icon"
                            className="h-8 w-8"
                            onClick={() => handleCloseRomanShadePopUp()}
                            data-qa="overview-popup-roman-shade-close"
                          >
                            <PopUpClose />
                          </Button>
                        </div>
                      </div>
                      <div>
                        <p className="text-[16px] leading-6 font-normal italic text-[#545454]">
                          Automated yardage and pricing COMING SOON!
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center justify-end">
                      <Button
                        type="button"
                        onClick={() => handleOpenRomanShadeOrder()}
                        data-qa="overview-popup-roman-shade-show"
                      >
                        Show me
                      </Button>
                    </div>
                  </div>
                </AnnouncementPopup>

                <AnnouncementPopup active={state.hardwarePopUp} dataQa="overview-popup-hardware">
                  <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-4">
                      <div className="flex gap-[21px]">
                        <div className="flex flex-col gap-2.5">
                          <span className="text-[32px] leading-[42px] text-primary">
                            New Drapery Order options available!
                          </span>
                          <span className="text-[16px] leading-6 font-normal text-[#545454]">
                            You asked and we delivered! We are excited to announce we have added two
                            new tabs to the Drapery Order:
                          </span>
                        </div>

                        <div className="flex items-center">
                          <Confetti style={{ width: '110px' }} />
                        </div>

                        <div>
                          <Button
                            type="button"
                            variant="ghost"
                            size="icon"
                            className="h-8 w-8"
                            onClick={() => handleCloseHardwarePopUp()}
                            data-qa="overview-popup-hardware-close"
                          >
                            <PopUpClose />
                          </Button>
                        </div>
                      </div>
                      <div>
                        <ul className="list-disc pl-5 text-[16px] leading-6 font-normal text-[#545454]">
                          <li>
                            Hardware - Document selections and hardware notes for your drapery
                            order.
                          </li>
                          <li>Uploads - Add pictures of your windows, measurements, and more.</li>
                        </ul>
                      </div>
                    </div>

                    <div className="flex items-center justify-end">
                      <Button
                        type="button"
                        onClick={() => handleOpenHardwareTab()}
                        data-qa="overview-popup-hardware-show"
                      >
                        Show me
                      </Button>
                    </div>
                  </div>
                </AnnouncementPopup>

                <AnnouncementPopup active={state.otherItemPopUp} dataQa="overview-popup-other-item">
                  <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-4">
                      <div className="flex gap-[21px]">
                        <div className="flex flex-col gap-2.5">
                          <span className="text-[32px] leading-[42px] text-primary">
                            NEW Order Form Released!
                          </span>
                          <span className="text-[16px] leading-6 font-normal text-[#545454]">
                            Pillows, Bedskirts, and Coverlets? Yes! Now you can keep track of all
                            those “other” items in QUIPA too. Find the “Other” order form by
                            clicking the <strong> Add Item </strong> button. In this order, you'll
                            be able to:
                          </span>
                        </div>
                        <div className="flex items-center">
                          <Confetti style={{ width: '110px' }} />
                        </div>
                        <div>
                          <Button
                            type="button"
                            variant="ghost"
                            size="icon"
                            className="h-8 w-8"
                            onClick={() => handleCloseOtherItemPopUp()}
                            data-qa="overview-popup-other-item-close"
                          >
                            <PopUpClose />
                          </Button>
                        </div>
                      </div>
                      <div>
                        <ul className="list-disc pl-5 text-[16px] leading-6 font-normal text-[#545454]">
                          <li>Collect the details</li>
                          <li>Create a Work Order</li>
                          <li>Track the project</li>
                        </ul>
                      </div>
                    </div>
                    <div className="flex items-center justify-end">
                      <Button
                        type="button"
                        onClick={() => handleOpenOtherItemOrder()}
                        data-qa="overview-popup-other-item-check"
                      >
                        Check it out
                      </Button>
                    </div>
                  </div>
                </AnnouncementPopup>

                <AnnouncementPopup
                  active={state.romanShadeCalculationsPopUp}
                  dataQa="overview-popup-roman-shade-calculations"
                >
                  <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-4">
                      <div className="flex gap-[21px]">
                        <div className="flex flex-col gap-2.5">
                          <span className="text-[32px] leading-[42px] text-primary">
                            Roman Shade Calculations are here!
                          </span>
                          <span className="text-[16px] leading-6 font-normal text-[#545454]">
                            We are excited to share that yardage and pricing are now automated on
                            the Roman Shade Order! <br />
                            <br />
                            Add your <strong>pricing</strong> (required) and{' '}
                            <strong>construction settings</strong> (recommended) for{' '}
                            <strong>Roman Shades</strong> in <strong>My Shop</strong> to use this
                            feature.
                          </span>
                        </div>
                        <div className="flex items-center">
                          <Confetti style={{ width: '110px' }} />
                        </div>
                        <div>
                          <Button
                            type="button"
                            variant="ghost"
                            size="icon"
                            className="h-8 w-8"
                            onClick={() => handleCloseRomanShadeCalculationsPopUp()}
                            data-qa="overview-popup-roman-shade-calculations-close"
                          >
                            <PopUpClose />
                          </Button>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center justify-end">
                      <Button
                        type="button"
                        onClick={() => handleOpenRomanShadeCalculationsPopUp()}
                        data-qa="overview-popup-roman-shade-calculations-setup"
                      >
                        Setup Now
                      </Button>
                    </div>
                  </div>
                </AnnouncementPopup>

                {!state.isPopUpModalOpen && (
                  <ConfirmationModal
                    uiActive={state.showModal === 'true'}
                    uiAcceptLabel="Ok"
                    uiHeader="Pop-ups Required"
                    uiDeclineLabel={false}
                    uiOnConfirm={handleCloseModal}
                    uiOnClose={() => {}}
                    uiOnRequestClose={() => {}}
                    uiCloseOnOutsideClick={true}
                    uiCloseOnEsc={true}
                    className="pop-up justify-end"
                    footerClassName="justify-end"
                  >
                    <p>
                      QUIPA utilizes pop-ups. Please ensure pop-ups are enabled for{' '}
                      <a href="https://my.quipa.com/">my.quipa.com </a>
                      in your browser settings.
                    </p>

                    <div className="mt-2 flex items-start gap-2">
                      <Checkbox
                        checked={state.isPopUpChecked}
                        onCheckedChange={(checked) => handleCheckModal(checked === true)}
                      />
                      <span className="text-sm">Do not show this message again</span>
                    </div>
                  </ConfirmationModal>
                )}
              </div>
            </div>
          </div>
        </div>
      </PageContent>

      {canManageTeamMembers ? (
        <WideSheet
          open={isInvitePanelOpen}
          onCancel={handleCloseInvitePanel}
          onSave={handleSubmitInvitePanel}
          title="Add"
          subTitle={
            invitePanelMode === 'team_member'
              ? 'Invite a team member with login access'
              : 'Add an assignee without login'
          }
          saveLabel={
            invitePanelMode === 'team_member'
              ? isInvitingMember
                ? 'Sending...'
                : 'Send Invitation'
              : 'Add Assignee'
          }
          cancelLabel="Cancel"
          saveDisabled={!canSubmitInvitePanel}
          overlayDataQa="team-settings-invite-panel-overlay-close"
          overlayStyle={{
            backgroundColor: 'rgba(0, 0, 0, 0.78)',
          }}
          closeButtonDataQa="team-settings-invite-panel-close-button"
          cancelButtonDataQa="team-settings-invite-panel-cancel"
          saveButtonDataQa="team-settings-invite-panel-submit"
        >
          <div>
            <div className="grid grid-cols-2 overflow-hidden rounded-[8px] border border-[#D8E0E8]">
              <button
                type="button"
                className={`border-0 py-3 text-[14px] font-semibold ${
                  invitePanelMode === 'team_member'
                    ? 'bg-[#3B97B1] text-white'
                    : 'bg-white text-[#64748B]'
                }`}
                onClick={() => handleSwitchInviteMode('team_member')}
                data-qa="team-settings-invite-panel-mode-team-member"
              >
                Add Team Member
              </button>
              <button
                type="button"
                className={`border-0 py-3 text-[14px] font-semibold ${
                  invitePanelMode === 'assignee'
                    ? 'bg-[#3B97B1] text-white'
                    : 'bg-white text-[#64748B]'
                }`}
                onClick={() => handleSwitchInviteMode('assignee')}
                data-qa="team-settings-invite-panel-mode-assignee"
              >
                Add Assignee
              </button>
            </div>

            <div className="mt-5 rounded-[8px] border border-[#D8E0E8] bg-[#f1f5f980] px-4 py-4">
              <div className="flex items-center gap-3">
                {invitePanelMode === 'team_member' ? (
                  <UserCheckIcon className="h-5 w-5 text-[#64748B]" />
                ) : (
                  <ClipboardList className="h-5 w-5 text-[#64748B]" />
                )}
                <h3 className="m-0 text-[14px] font-semibold text-[#111827]">
                  {invitePanelMode === 'team_member' ? 'Team Member' : 'Assignees without login'}
                </h3>
              </div>
              <ul className="m-0 mt-3 list-outside list-disc pl-14 text-[14px] text-[#60778F]">
                {invitePanelMode === 'team_member' ? (
                  <>
                    <li>Creates a Quipa user with login access</li>
                    <li>Can log in and view assigned work</li>
                    <li>Can collaborate with the team</li>
                    <li>Receives notifications and @mentions</li>
                    <li>Uses a paid seat</li>
                  </>
                ) : (
                  <>
                    <li>People you assign work to who do not have Quipa access</li>
                    <li>Appear in assignee lists</li>
                    <li>Do not receive notifications or @mentions</li>
                  </>
                )}
              </ul>
            </div>

            {invitePanelMode === 'team_member' ? (
              <>
                <div className="mt-5 rounded-[8px] bg-[#f1f5f980] px-4 py-4">
                  <h3 className="m-0 text-[16px] font-semibold text-[#111827]">
                    Contact Information
                  </h3>
                  <label className="mt-4 block text-[14px] font-semibold text-[#111827]">
                    Email
                  </label>
                  <div className="relative mt-2">
                    <Mail className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#60778F]" />
                    <Input
                      type="email"
                      placeholder="teammate@company.com"
                      value={memberEmail}
                      onChange={(e) => setMemberEmail(e.target.value)}
                      className="h-11 pl-9"
                      data-qa="team-settings-invite-member-email-input"
                    />
                  </div>
                </div>

                <div className="mt-5 rounded-[8px] bg-[#f1f5f980] px-4 py-4">
                  <h3 className="m-0 text-[16px] font-semibold text-[#111827]">Roles</h3>
                  <p className="mb-0 mt-4 text-[14px] text-[#60778F]">
                    Assign work roles to describe what type of work this person does.
                  </p>
                  <div className="mt-4 rounded-[8px] border border-[#D8E0E8] bg-white px-3 py-3">
                    {roles.length === 0 ? (
                      <p className="m-0 text-[14px] text-[#64748B]">
                        No roles created yet. Add roles in the Roles tab first.
                      </p>
                    ) : (
                      <div className="flex flex-col gap-3">
                        {roles.map((role) => (
                          <label
                            key={`member-role-${role.id}`}
                            className="flex items-center gap-3 text-[14px] font-semibold text-[#111827]"
                            data-qa={`team-settings-invite-member-role-${role.id}-label`}
                          >
                            <Checkbox
                              checked={memberSelectedRoleIds.includes(role.id)}
                              onCheckedChange={(checked) =>
                                toggleMemberRole(role.id, checked === true)
                              }
                              data-qa={`team-settings-invite-member-role-${role.id}-checkbox`}
                            />
                            <span>{role.name}</span>
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className="mt-5 rounded-[8px] bg-[#f1f5f980] px-4 py-4">
                  <h3 className="m-0 text-[16px] font-semibold text-[#111827]">Permissions</h3>
                  <div className="mt-4 flex flex-col gap-3">
                    <div className="relative inline-flex w-fit items-center gap-3 text-[14px] text-[#111827]">
                      <Checkbox
                        checked={memberPricingAccess}
                        onCheckedChange={(checked) => setMemberPricingAccess(checked === true)}
                        data-qa="team-settings-invite-member-pricing-access-checkbox"
                      />
                      <span>Pricing access</span>
                      <PermissionHelpTooltip
                        tooltipKey="pricing"
                        enabled={isInvitePanelOpen}
                        open={openPermissionTooltip === 'pricing'}
                        onOpenChange={(nextOpen) =>
                          setOpenPermissionTooltip(nextOpen ? 'pricing' : null)
                        }
                        ariaLabel="Show pricing access help"
                        content="View and edit item details, construction settings, and My Shop entries."
                        width={290}
                        triggerDataQa="team-settings-invite-member-pricing-access-help"
                        contentDataQa="team-settings-invite-member-pricing-access-help-content"
                      />
                    </div>
                    <div className="relative inline-flex w-fit items-center gap-3 text-[14px] text-[#111827]">
                      <Checkbox
                        checked={memberAdminAccess}
                        onCheckedChange={(checked) => setMemberAdminAccess(checked === true)}
                        data-qa="team-settings-invite-member-admin-access-checkbox"
                      />
                      <span>Administration access</span>
                      <PermissionHelpTooltip
                        tooltipKey="admin"
                        enabled={isInvitePanelOpen}
                        open={openPermissionTooltip === 'admin'}
                        onOpenChange={(nextOpen) =>
                          setOpenPermissionTooltip(nextOpen ? 'admin' : null)
                        }
                        ariaLabel="Show administration access help"
                        content="Manage account settings, users and roles, integrations, and workspace configuration."
                        width={320}
                        triggerDataQa="team-settings-invite-member-admin-access-help"
                        contentDataQa="team-settings-invite-member-admin-access-help-content"
                      />
                    </div>
                  </div>
                </div>

                {isSeatLimitReached ? (
                  <div className="mt-5 rounded-[8px] bg-[#f1f5f980] px-4 py-4">
                    <div className="flex items-center gap-2">
                      <TriangleAlert className="h-5 w-5 text-[#F59E0B]" />
                      <h3 className="m-0 text-[16px] font-semibold text-[#C66A00]">
                        Seat Limit Reached
                      </h3>
                    </div>
                    <p className="m-0 mt-4 text-[14px] text-[#60778F]">
                      You have reached the seat limit for your account.{' '}
                      <button
                        type="button"
                        className="inline cursor-pointer border-0 bg-transparent p-0 text-[#2F8FB0] hover:text-[#267990]"
                        onClick={() => handleOpenSeatsModal(true)}
                        data-qa="team_settings_add_seats_button_link"
                      >
                        Add more seats
                      </button>{' '}
                      or{' '}
                      <button
                        type="button"
                        className="inline cursor-pointer border-0 bg-transparent p-0 text-[#2F8FB0] hover:text-[#267990]"
                        onClick={() => {
                          void handleChangePlan();
                        }}
                        data-qa="team-settings-invite-seat-limit-upgrade-plan"
                      >
                        Upgrade your plan
                      </button>
                    </p>
                    <div className="mt-4 flex flex-wrap items-center gap-3">
                      <Dialog
                        open={openSeatsModal}
                        onOpenChange={(val) => handleOpenSeatsModal(val)}
                      >
                        <DialogTrigger asChild>
                          <Button
                            type="button"
                            variant={'default'}
                            className="min-h-[36px]"
                            // onClick={() => handleOpenSeatsModal(true)}
                            // disabled={false}
                            data-qa="team_settings_add_seats_button"
                          >
                            Add Seats
                          </Button>
                        </DialogTrigger>
                        <DialogContent className="max-w-[700px]">
                          <DialogHeader>
                            <DialogTitle className="m-0 text-[24px]">Buy Extra Seats</DialogTitle>
                          </DialogHeader>

                          <div className="flex flex-col gap-4">
                            <div className="md:text-start text-center md:ml-4">
                              <RadioGroup
                                disabled={seatLoading}
                                className="flex items-center gap-1 rounded-md w-max"
                                value={seatState.interval}
                                onValueChange={(val) => handleChangeInterval(val)}
                              >
                                <div className="">
                                  <RadioGroupItem
                                    value={'month'}
                                    id="seat_monthly"
                                    className="hidden"
                                  />
                                  <Label
                                    data-loading={seatLoading}
                                    data-checked={seatState.interval === 'month'}
                                    htmlFor="seat_monthly"
                                    className="transition duration-300 cursor-pointer px-[12px] py-[8px] rounded-md data-[checked=true]:shadow-[0_0_0_2px_rgba(59,151,177,1)] border border-input data-[checked=false]:bg-white data-[loading=true]:opacity-50"
                                  >
                                    Monthly
                                  </Label>
                                </div>
                                <div className="">
                                  <RadioGroupItem
                                    value={'year'}
                                    id="seat_yearly"
                                    className="hidden"
                                  />
                                  <Label
                                    data-loading={seatLoading}
                                    data-checked={seatState.interval === 'year'}
                                    htmlFor="seat_yearly"
                                    className="transition duration-300 cursor-pointer px-[12px] py-[8px] rounded-md data-[checked=true]:shadow-[0_0_0_2px_rgba(59,151,177,1)] border border-input data-[checked=false]:bg-white data-[loading=true]:opacity-50"
                                  >
                                    Yearly
                                  </Label>
                                </div>
                              </RadioGroup>
                            </div>

                            <div className="p-[24px] rounded-[12px] border border-2 border-primary_dark">
                              <div className="flex md:flex-row flex-col justify-between gap-2">
                                <div>
                                  <div className="mb-4 flex items-center gap-2">
                                    <div>
                                      <Input
                                        disabled={seatLoading}
                                        onChange={(e) => handleChangeSeatQty(e)}
                                        className="px-1 text-center max-w-[60px] min-h-[10px] max-h-max"
                                        value={seatState.quantity}
                                        autoFocus
                                      />
                                    </div>
                                    <span className="text-[18px] font-medium">
                                      Extra Seat{Number(seatState.quantity) > 1 ? 's' : ''}
                                    </span>
                                  </div>

                                  <div>
                                    <span>
                                      $
                                      {(
                                        (+seatState.cost || 0) * (+seatState.quantity || 0)
                                      ).toFixed(2)}{' '}
                                      per {seatState.interval}
                                    </span>
                                  </div>
                                </div>

                                <div className="flex items-center">
                                  <div className="flex items-center gap-2 px-[16px] py-[8px] border border-input rounded-md">
                                    <CircleCheck className="w-[16px] h-[16px] text-primary" />
                                    <span>Selected</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <DialogFooter>
                            <DialogClose>
                              <Button type="button" variant={'outline'}>
                                Close
                              </Button>
                            </DialogClose>
                            <Button
                              disabled={seatLoading || !seatState.quantity}
                              onClick={() => handleBuyMoreSeats()}
                              type="button"
                            >
                              Buy
                            </Button>
                          </DialogFooter>
                        </DialogContent>
                      </Dialog>

                      <Button
                        variant={'outline'}
                        type="button"
                        className="font-medium min-h-[36px]"
                        onClick={() => {
                          void handleRemoveInactiveMembers();
                        }}
                        disabled={isRemovingInactiveMembers || isInvitationActionDisabled()}
                        data-qa="team-settings-invite-seat-limit-remove-inactive-members"
                      >
                        {isRemovingInactiveMembers ? 'Removing...' : 'Remove inactive members'}
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="mt-5 rounded-[8px] bg-[#f1f5f980] px-4 py-4">
                    <div className="flex items-center gap-3">
                      <CreditCard className="h-5 w-5 text-[#64748B]" />
                      <h3 className="m-0 text-[16px] font-semibold text-[#111827]">Seat Usage</h3>
                    </div>
                    <p className="mb-0 mt-4 text-[14px] text-[#111827]">
                      Current: {usedSlots} of {availableSlots} seats used
                    </p>
                    <div className="mt-3 h-[8px] rounded-full bg-[#D7E2E9]">
                      <div
                        className="h-full rounded-full bg-[#3B97B1]"
                        style={{ width: `${seatUsagePercent}%` }}
                      />
                    </div>
                    <p className="m-0 mt-4 text-[14px] text-[#60778F]">
                      Sending this invitation will use 1 seat. You will have{' '}
                      {remainingSeatsAfterInvite} seats remaining.
                    </p>
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="mt-5 rounded-[8px] bg-[#f1f5f980] px-4 py-4">
                  <h3 className="m-0 text-[16px] font-semibold text-[#111827]">
                    Assignee Information
                  </h3>
                  <label className="mt-4 block text-[14px] font-semibold text-[#111827]">
                    Name *
                  </label>
                  <div className="relative mt-2">
                    <UserRound className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#60778F]" />
                    <Input
                      type="text"
                      placeholder="John Smith"
                      value={assigneeName}
                      onChange={(e) => handleAssigneeNameChange(e.target.value)}
                      className="h-11 pl-9"
                      data-qa="team-settings-invite-assignee-name-input"
                    />
                  </div>

                  <label className="mt-4 block text-[14px] font-semibold text-[#111827]">
                    Label * <span className="font-normal text-[#60778F]">(1-4 chars)</span>
                  </label>
                  <div className="relative mt-2">
                    <AtSign className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#60778F]" />
                    <Input
                      type="text"
                      placeholder="JS"
                      value={assigneeLabel}
                      onChange={(e) => handleAssigneeLabelChange(e.target.value)}
                      className="h-11 pl-9"
                      data-qa="team-settings-invite-assignee-label-input"
                    />
                  </div>
                  <p className="m-0 mt-2 text-[14px] text-[#60778F]">Used for @mentions</p>
                </div>

                <div className="mt-5 rounded-[8px] bg-[#f1f5f980] px-4 py-4">
                  <h3 className="m-0 text-[16px] font-semibold text-[#111827]">Roles *</h3>
                  <p className="mb-0 mt-4 text-[14px] text-[#60778F]">
                    Select at least one role to describe what type of work this person does.
                  </p>
                  <div className="mt-4 rounded-[8px] border border-[#D8E0E8] bg-white px-3 py-3">
                    {roles.length === 0 ? (
                      <p className="m-0 text-[14px] text-[#64748B]">
                        No roles created yet. Add roles in the Roles tab first.
                      </p>
                    ) : (
                      <div className="flex flex-col gap-3">
                        {roles.map((role) => (
                          <label
                            key={`assignee-role-${role.id}`}
                            className="flex items-center gap-3 text-[14px] font-semibold text-[#111827]"
                            data-qa={`team-settings-invite-assignee-role-${role.id}-label`}
                          >
                            <Checkbox
                              checked={assigneeSelectedRoleIds.includes(role.id)}
                              onCheckedChange={(checked) =>
                                toggleAssigneeRole(role.id, checked === true)
                              }
                              data-qa={`team-settings-invite-assignee-role-${role.id}-checkbox`}
                            />
                            <span>{role.name}</span>
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </WideSheet>
      ) : null}
    </>
  );
};

function mapStateToProps(state: RootState, ownProps: OverviewOwnProps): OverviewProps {
  const user = localStorage.getItem('quipa-store');
  const email = user ? JSON.parse(user).user.email : '';

  return {
    ...ownProps,
    accountId: parseFloat(localStorage.getItem('accountId') || '0'),
    email: email,
    firstName: localStorage.getItem('firstName') || '',
    lastName: localStorage.getItem('lastName') || '',
  };
}

export const Overview = connect(mapStateToProps)(OverviewPage);
